const zipCodeArr = [
  {
    countyName: "Allegany",
    zipCode: 14024,
  },
  {
    countyName: "Allegany",
    zipCode: 14029,
  },
  {
    countyName: "Allegany",
    zipCode: 14060,
  },
  {
    countyName: "Allegany",
    zipCode: 14065,
  },
  {
    countyName: "Allegany",
    zipCode: 14437,
  },
  {
    countyName: "Allegany",
    zipCode: 14536,
  },
  {
    countyName: "Allegany",
    zipCode: 14707,
  },
  {
    countyName: "Allegany",
    zipCode: 14708,
  },
  {
    countyName: "Allegany",
    zipCode: 14709,
  },
  {
    countyName: "Allegany",
    zipCode: 14711,
  },
  {
    countyName: "Allegany",
    zipCode: 14714,
  },
  {
    countyName: "Allegany",
    zipCode: 14715,
  },
  {
    countyName: "Allegany",
    zipCode: 14717,
  },
  {
    countyName: "Allegany",
    zipCode: 14721,
  },
  {
    countyName: "Allegany",
    zipCode: 14727,
  },
  {
    countyName: "Allegany",
    zipCode: 14735,
  },
  {
    countyName: "Allegany",
    zipCode: 14737,
  },
  {
    countyName: "Allegany",
    zipCode: 14739,
  },
  {
    countyName: "Allegany",
    zipCode: 14744,
  },
  {
    countyName: "Allegany",
    zipCode: 14745,
  },
  {
    countyName: "Allegany",
    zipCode: 14754,
  },
  {
    countyName: "Allegany",
    zipCode: 14770,
  },
  {
    countyName: "Allegany",
    zipCode: 14774,
  },
  {
    countyName: "Allegany",
    zipCode: 14777,
  },
  {
    countyName: "Allegany",
    zipCode: 14786,
  },
  {
    countyName: "Allegany",
    zipCode: 14802,
  },
  {
    countyName: "Allegany",
    zipCode: 14803,
  },
  {
    countyName: "Allegany",
    zipCode: 14804,
  },
  {
    countyName: "Allegany",
    zipCode: 14806,
  },
  {
    countyName: "Allegany",
    zipCode: 14807,
  },
  {
    countyName: "Allegany",
    zipCode: 14813,
  },
  {
    countyName: "Allegany",
    zipCode: 14822,
  },
  {
    countyName: "Allegany",
    zipCode: 14836,
  },
  {
    countyName: "Allegany",
    zipCode: 14843,
  },
  {
    countyName: "Allegany",
    zipCode: 14846,
  },
  {
    countyName: "Allegany",
    zipCode: 14880,
  },
  {
    countyName: "Allegany",
    zipCode: 14884,
  },
  {
    countyName: "Allegany",
    zipCode: 14895,
  },
  {
    countyName: "Allegany",
    zipCode: 14897,
  },
  {
    countyName: "Broome",
    zipCode: 13730,
  },
  {
    countyName: "Broome",
    zipCode: 13736,
  },
  {
    countyName: "Broome",
    zipCode: 13737,
  },
  {
    countyName: "Broome",
    zipCode: 13744,
  },
  {
    countyName: "Broome",
    zipCode: 13745,
  },
  {
    countyName: "Broome",
    zipCode: 13746,
  },
  {
    countyName: "Broome",
    zipCode: 13748,
  },
  {
    countyName: "Broome",
    zipCode: 13749,
  },
  {
    countyName: "Broome",
    zipCode: 13754,
  },
  {
    countyName: "Broome",
    zipCode: 13760,
  },
  {
    countyName: "Broome",
    zipCode: 13761,
  },
  {
    countyName: "Broome",
    zipCode: 13762,
  },
  {
    countyName: "Broome",
    zipCode: 13763,
  },
  {
    countyName: "Broome",
    zipCode: 13777,
  },
  {
    countyName: "Broome",
    zipCode: 13778,
  },
  {
    countyName: "Broome",
    zipCode: 13787,
  },
  {
    countyName: "Broome",
    zipCode: 13790,
  },
  {
    countyName: "Broome",
    zipCode: 13794,
  },
  {
    countyName: "Broome",
    zipCode: 13795,
  },
  {
    countyName: "Broome",
    zipCode: 13797,
  },
  {
    countyName: "Broome",
    zipCode: 13802,
  },
  {
    countyName: "Broome",
    zipCode: 13803,
  },
  {
    countyName: "Broome",
    zipCode: 13811,
  },
  {
    countyName: "Broome",
    zipCode: 13813,
  },
  {
    countyName: "Broome",
    zipCode: 13826,
  },
  {
    countyName: "Broome",
    zipCode: 13833,
  },
  {
    countyName: "Broome",
    zipCode: 13835,
  },
  {
    countyName: "Broome",
    zipCode: 13848,
  },
  {
    countyName: "Broome",
    zipCode: 13850,
  },
  {
    countyName: "Broome",
    zipCode: 13851,
  },
  {
    countyName: "Broome",
    zipCode: 13862,
  },
  {
    countyName: "Broome",
    zipCode: 13863,
  },
  {
    countyName: "Broome",
    zipCode: 13865,
  },
  {
    countyName: "Broome",
    zipCode: 13901,
  },
  {
    countyName: "Broome",
    zipCode: 13902,
  },
  {
    countyName: "Broome",
    zipCode: 13903,
  },
  {
    countyName: "Broome",
    zipCode: 13904,
  },
  {
    countyName: "Broome",
    zipCode: 13905,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14009,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14030,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14041,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14042,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14060,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14065,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14070,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14081,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14101,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14129,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14133,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14138,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14141,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14168,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14171,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14173,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14706,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14719,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14726,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14727,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14729,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14730,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14731,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14737,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14738,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14741,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14743,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14747,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14748,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14751,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14753,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14755,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14760,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14766,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14770,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14772,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14778,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14779,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14783,
  },
  {
    countyName: "Cattaraugus",
    zipCode: 14788,
  },
  {
    countyName: "Cayuga",
    zipCode: 13021,
  },
  {
    countyName: "Cayuga",
    zipCode: 13022,
  },
  {
    countyName: "Cayuga",
    zipCode: 13024,
  },
  {
    countyName: "Cayuga",
    zipCode: 13026,
  },
  {
    countyName: "Cayuga",
    zipCode: 13027,
  },
  {
    countyName: "Cayuga",
    zipCode: 13033,
  },
  {
    countyName: "Cayuga",
    zipCode: 13034,
  },
  {
    countyName: "Cayuga",
    zipCode: 13045,
  },
  {
    countyName: "Cayuga",
    zipCode: 13064,
  },
  {
    countyName: "Cayuga",
    zipCode: 13071,
  },
  {
    countyName: "Cayuga",
    zipCode: 13073,
  },
  {
    countyName: "Cayuga",
    zipCode: 13074,
  },
  {
    countyName: "Cayuga",
    zipCode: 13080,
  },
  {
    countyName: "Cayuga",
    zipCode: 13081,
  },
  {
    countyName: "Cayuga",
    zipCode: 13092,
  },
  {
    countyName: "Cayuga",
    zipCode: 13111,
  },
  {
    countyName: "Cayuga",
    zipCode: 13113,
  },
  {
    countyName: "Cayuga",
    zipCode: 13117,
  },
  {
    countyName: "Cayuga",
    zipCode: 13118,
  },
  {
    countyName: "Cayuga",
    zipCode: 13126,
  },
  {
    countyName: "Cayuga",
    zipCode: 13139,
  },
  {
    countyName: "Cayuga",
    zipCode: 13140,
  },
  {
    countyName: "Cayuga",
    zipCode: 13143,
  },
  {
    countyName: "Cayuga",
    zipCode: 13147,
  },
  {
    countyName: "Cayuga",
    zipCode: 13152,
  },
  {
    countyName: "Cayuga",
    zipCode: 13156,
  },
  {
    countyName: "Cayuga",
    zipCode: 13160,
  },
  {
    countyName: "Cayuga",
    zipCode: 13166,
  },
  {
    countyName: "Cayuga",
    zipCode: 14882,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14048,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14062,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14063,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14081,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14135,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14136,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14138,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14166,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14701,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14702,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14710,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14712,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14716,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14718,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14720,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14722,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14723,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14724,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14726,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14728,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14732,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14733,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14736,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14738,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14740,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14742,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14747,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14750,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14752,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14756,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14757,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14758,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14767,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14769,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14775,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14781,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14782,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14784,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14785,
  },
  {
    countyName: "Chautauqua",
    zipCode: 14787,
  },
  {
    countyName: "Chemung",
    zipCode: 14805,
  },
  {
    countyName: "Chemung",
    zipCode: 14812,
  },
  {
    countyName: "Chemung",
    zipCode: 14814,
  },
  {
    countyName: "Chemung",
    zipCode: 14816,
  },
  {
    countyName: "Chemung",
    zipCode: 14824,
  },
  {
    countyName: "Chemung",
    zipCode: 14825,
  },
  {
    countyName: "Chemung",
    zipCode: 14830,
  },
  {
    countyName: "Chemung",
    zipCode: 14838,
  },
  {
    countyName: "Chemung",
    zipCode: 14845,
  },
  {
    countyName: "Chemung",
    zipCode: 14859,
  },
  {
    countyName: "Chemung",
    zipCode: 14861,
  },
  {
    countyName: "Chemung",
    zipCode: 14864,
  },
  {
    countyName: "Chemung",
    zipCode: 14871,
  },
  {
    countyName: "Chemung",
    zipCode: 14872,
  },
  {
    countyName: "Chemung",
    zipCode: 14889,
  },
  {
    countyName: "Chemung",
    zipCode: 14892,
  },
  {
    countyName: "Chemung",
    zipCode: 14894,
  },
  {
    countyName: "Chemung",
    zipCode: 14901,
  },
  {
    countyName: "Chemung",
    zipCode: 14902,
  },
  {
    countyName: "Chemung",
    zipCode: 14903,
  },
  {
    countyName: "Chemung",
    zipCode: 14904,
  },
  {
    countyName: "Chemung",
    zipCode: 14905,
  },
  {
    countyName: "Chemung",
    zipCode: 14925,
  },
  {
    countyName: "Chenango",
    zipCode: 13040,
  },
  {
    countyName: "Chenango",
    zipCode: 13052,
  },
  {
    countyName: "Chenango",
    zipCode: 13072,
  },
  {
    countyName: "Chenango",
    zipCode: 13124,
  },
  {
    countyName: "Chenango",
    zipCode: 13136,
  },
  {
    countyName: "Chenango",
    zipCode: 13155,
  },
  {
    countyName: "Chenango",
    zipCode: 13332,
  },
  {
    countyName: "Chenango",
    zipCode: 13411,
  },
  {
    countyName: "Chenango",
    zipCode: 13460,
  },
  {
    countyName: "Chenango",
    zipCode: 13464,
  },
  {
    countyName: "Chenango",
    zipCode: 13485,
  },
  {
    countyName: "Chenango",
    zipCode: 13730,
  },
  {
    countyName: "Chenango",
    zipCode: 13733,
  },
  {
    countyName: "Chenango",
    zipCode: 13746,
  },
  {
    countyName: "Chenango",
    zipCode: 13758,
  },
  {
    countyName: "Chenango",
    zipCode: 13778,
  },
  {
    countyName: "Chenango",
    zipCode: 13780,
  },
  {
    countyName: "Chenango",
    zipCode: 13787,
  },
  {
    countyName: "Chenango",
    zipCode: 13801,
  },
  {
    countyName: "Chenango",
    zipCode: 13809,
  },
  {
    countyName: "Chenango",
    zipCode: 13813,
  },
  {
    countyName: "Chenango",
    zipCode: 13814,
  },
  {
    countyName: "Chenango",
    zipCode: 13815,
  },
  {
    countyName: "Chenango",
    zipCode: 13830,
  },
  {
    countyName: "Chenango",
    zipCode: 13832,
  },
  {
    countyName: "Chenango",
    zipCode: 13833,
  },
  {
    countyName: "Chenango",
    zipCode: 13841,
  },
  {
    countyName: "Chenango",
    zipCode: 13843,
  },
  {
    countyName: "Chenango",
    zipCode: 13844,
  },
  {
    countyName: "Chenango",
    zipCode: 13863,
  },
  {
    countyName: "Clinton",
    zipCode: 12901,
  },
  {
    countyName: "Clinton",
    zipCode: 12903,
  },
  {
    countyName: "Clinton",
    zipCode: 12910,
  },
  {
    countyName: "Clinton",
    zipCode: 12911,
  },
  {
    countyName: "Clinton",
    zipCode: 12912,
  },
  {
    countyName: "Clinton",
    zipCode: 12918,
  },
  {
    countyName: "Clinton",
    zipCode: 12919,
  },
  {
    countyName: "Clinton",
    zipCode: 12920,
  },
  {
    countyName: "Clinton",
    zipCode: 12921,
  },
  {
    countyName: "Clinton",
    zipCode: 12923,
  },
  {
    countyName: "Clinton",
    zipCode: 12924,
  },
  {
    countyName: "Clinton",
    zipCode: 12929,
  },
  {
    countyName: "Clinton",
    zipCode: 12933,
  },
  {
    countyName: "Clinton",
    zipCode: 12934,
  },
  {
    countyName: "Clinton",
    zipCode: 12935,
  },
  {
    countyName: "Clinton",
    zipCode: 12944,
  },
  {
    countyName: "Clinton",
    zipCode: 12952,
  },
  {
    countyName: "Clinton",
    zipCode: 12955,
  },
  {
    countyName: "Clinton",
    zipCode: 12958,
  },
  {
    countyName: "Clinton",
    zipCode: 12959,
  },
  {
    countyName: "Clinton",
    zipCode: 12962,
  },
  {
    countyName: "Clinton",
    zipCode: 12972,
  },
  {
    countyName: "Clinton",
    zipCode: 12978,
  },
  {
    countyName: "Clinton",
    zipCode: 12979,
  },
  {
    countyName: "Clinton",
    zipCode: 12981,
  },
  {
    countyName: "Clinton",
    zipCode: 12985,
  },
  {
    countyName: "Clinton",
    zipCode: 12992,
  },
  {
    countyName: "Clinton",
    zipCode: 12997,
  },
  {
    countyName: "Columbia",
    zipCode: 12017,
  },
  {
    countyName: "Columbia",
    zipCode: 12024,
  },
  {
    countyName: "Columbia",
    zipCode: 12029,
  },
  {
    countyName: "Columbia",
    zipCode: 12037,
  },
  {
    countyName: "Columbia",
    zipCode: 12050,
  },
  {
    countyName: "Columbia",
    zipCode: 12060,
  },
  {
    countyName: "Columbia",
    zipCode: 12062,
  },
  {
    countyName: "Columbia",
    zipCode: 12075,
  },
  {
    countyName: "Columbia",
    zipCode: 12106,
  },
  {
    countyName: "Columbia",
    zipCode: 12115,
  },
  {
    countyName: "Columbia",
    zipCode: 12123,
  },
  {
    countyName: "Columbia",
    zipCode: 12125,
  },
  {
    countyName: "Columbia",
    zipCode: 12130,
  },
  {
    countyName: "Columbia",
    zipCode: 12132,
  },
  {
    countyName: "Columbia",
    zipCode: 12136,
  },
  {
    countyName: "Columbia",
    zipCode: 12156,
  },
  {
    countyName: "Columbia",
    zipCode: 12165,
  },
  {
    countyName: "Columbia",
    zipCode: 12168,
  },
  {
    countyName: "Columbia",
    zipCode: 12172,
  },
  {
    countyName: "Columbia",
    zipCode: 12173,
  },
  {
    countyName: "Columbia",
    zipCode: 12174,
  },
  {
    countyName: "Columbia",
    zipCode: 12184,
  },
  {
    countyName: "Columbia",
    zipCode: 12195,
  },
  {
    countyName: "Columbia",
    zipCode: 12502,
  },
  {
    countyName: "Columbia",
    zipCode: 12503,
  },
  {
    countyName: "Columbia",
    zipCode: 12513,
  },
  {
    countyName: "Columbia",
    zipCode: 12516,
  },
  {
    countyName: "Columbia",
    zipCode: 12517,
  },
  {
    countyName: "Columbia",
    zipCode: 12521,
  },
  {
    countyName: "Columbia",
    zipCode: 12523,
  },
  {
    countyName: "Columbia",
    zipCode: 12526,
  },
  {
    countyName: "Columbia",
    zipCode: 12529,
  },
  {
    countyName: "Columbia",
    zipCode: 12530,
  },
  {
    countyName: "Columbia",
    zipCode: 12534,
  },
  {
    countyName: "Columbia",
    zipCode: 12541,
  },
  {
    countyName: "Columbia",
    zipCode: 12544,
  },
  {
    countyName: "Columbia",
    zipCode: 12546,
  },
  {
    countyName: "Columbia",
    zipCode: 12565,
  },
  {
    countyName: "Columbia",
    zipCode: 12567,
  },
  {
    countyName: "Columbia",
    zipCode: 12571,
  },
  {
    countyName: "Columbia",
    zipCode: 12583,
  },
  {
    countyName: "Cortland",
    zipCode: 13040,
  },
  {
    countyName: "Cortland",
    zipCode: 13045,
  },
  {
    countyName: "Cortland",
    zipCode: 13052,
  },
  {
    countyName: "Cortland",
    zipCode: 13053,
  },
  {
    countyName: "Cortland",
    zipCode: 13056,
  },
  {
    countyName: "Cortland",
    zipCode: 13077,
  },
  {
    countyName: "Cortland",
    zipCode: 13087,
  },
  {
    countyName: "Cortland",
    zipCode: 13101,
  },
  {
    countyName: "Cortland",
    zipCode: 13141,
  },
  {
    countyName: "Cortland",
    zipCode: 13158,
  },
  {
    countyName: "Cortland",
    zipCode: 13159,
  },
  {
    countyName: "Cortland",
    zipCode: 13738,
  },
  {
    countyName: "Cortland",
    zipCode: 13784,
  },
  {
    countyName: "Cortland",
    zipCode: 13803,
  },
  {
    countyName: "Cortland",
    zipCode: 13835,
  },
  {
    countyName: "Cortland",
    zipCode: 13863,
  },
  {
    countyName: "Delaware",
    zipCode: 12093,
  },
  {
    countyName: "Delaware",
    zipCode: 12155,
  },
  {
    countyName: "Delaware",
    zipCode: 12167,
  },
  {
    countyName: "Delaware",
    zipCode: 12406,
  },
  {
    countyName: "Delaware",
    zipCode: 12421,
  },
  {
    countyName: "Delaware",
    zipCode: 12430,
  },
  {
    countyName: "Delaware",
    zipCode: 12434,
  },
  {
    countyName: "Delaware",
    zipCode: 12438,
  },
  {
    countyName: "Delaware",
    zipCode: 12455,
  },
  {
    countyName: "Delaware",
    zipCode: 12459,
  },
  {
    countyName: "Delaware",
    zipCode: 12465,
  },
  {
    countyName: "Delaware",
    zipCode: 12468,
  },
  {
    countyName: "Delaware",
    zipCode: 12474,
  },
  {
    countyName: "Delaware",
    zipCode: 12758,
  },
  {
    countyName: "Delaware",
    zipCode: 12760,
  },
  {
    countyName: "Delaware",
    zipCode: 12776,
  },
  {
    countyName: "Delaware",
    zipCode: 13731,
  },
  {
    countyName: "Delaware",
    zipCode: 13733,
  },
  {
    countyName: "Delaware",
    zipCode: 13739,
  },
  {
    countyName: "Delaware",
    zipCode: 13740,
  },
  {
    countyName: "Delaware",
    zipCode: 13750,
  },
  {
    countyName: "Delaware",
    zipCode: 13751,
  },
  {
    countyName: "Delaware",
    zipCode: 13752,
  },
  {
    countyName: "Delaware",
    zipCode: 13753,
  },
  {
    countyName: "Delaware",
    zipCode: 13754,
  },
  {
    countyName: "Delaware",
    zipCode: 13755,
  },
  {
    countyName: "Delaware",
    zipCode: 13756,
  },
  {
    countyName: "Delaware",
    zipCode: 13757,
  },
  {
    countyName: "Delaware",
    zipCode: 13774,
  },
  {
    countyName: "Delaware",
    zipCode: 13775,
  },
  {
    countyName: "Delaware",
    zipCode: 13782,
  },
  {
    countyName: "Delaware",
    zipCode: 13783,
  },
  {
    countyName: "Delaware",
    zipCode: 13786,
  },
  {
    countyName: "Delaware",
    zipCode: 13788,
  },
  {
    countyName: "Delaware",
    zipCode: 13804,
  },
  {
    countyName: "Delaware",
    zipCode: 13806,
  },
  {
    countyName: "Delaware",
    zipCode: 13820,
  },
  {
    countyName: "Delaware",
    zipCode: 13825,
  },
  {
    countyName: "Delaware",
    zipCode: 13838,
  },
  {
    countyName: "Delaware",
    zipCode: 13839,
  },
  {
    countyName: "Delaware",
    zipCode: 13842,
  },
  {
    countyName: "Delaware",
    zipCode: 13846,
  },
  {
    countyName: "Delaware",
    zipCode: 13847,
  },
  {
    countyName: "Delaware",
    zipCode: 13849,
  },
  {
    countyName: "Delaware",
    zipCode: 13856,
  },
  {
    countyName: "Delaware",
    zipCode: 13860,
  },
  {
    countyName: "Erie",
    zipCode: 14001,
  },
  {
    countyName: "Erie",
    zipCode: 14004,
  },
  {
    countyName: "Erie",
    zipCode: 14006,
  },
  {
    countyName: "Erie",
    zipCode: 14010,
  },
  {
    countyName: "Erie",
    zipCode: 14013,
  },
  {
    countyName: "Erie",
    zipCode: 14025,
  },
  {
    countyName: "Erie",
    zipCode: 14026,
  },
  {
    countyName: "Erie",
    zipCode: 14027,
  },
  {
    countyName: "Erie",
    zipCode: 14030,
  },
  {
    countyName: "Erie",
    zipCode: 14031,
  },
  {
    countyName: "Erie",
    zipCode: 14032,
  },
  {
    countyName: "Erie",
    zipCode: 14033,
  },
  {
    countyName: "Erie",
    zipCode: 14034,
  },
  {
    countyName: "Erie",
    zipCode: 14035,
  },
  {
    countyName: "Erie",
    zipCode: 14037,
  },
  {
    countyName: "Erie",
    zipCode: 14038,
  },
  {
    countyName: "Erie",
    zipCode: 14043,
  },
  {
    countyName: "Erie",
    zipCode: 14047,
  },
  {
    countyName: "Erie",
    zipCode: 14051,
  },
  {
    countyName: "Erie",
    zipCode: 14052,
  },
  {
    countyName: "Erie",
    zipCode: 14055,
  },
  {
    countyName: "Erie",
    zipCode: 14057,
  },
  {
    countyName: "Erie",
    zipCode: 14059,
  },
  {
    countyName: "Erie",
    zipCode: 14061,
  },
  {
    countyName: "Erie",
    zipCode: 14068,
  },
  {
    countyName: "Erie",
    zipCode: 14069,
  },
  {
    countyName: "Erie",
    zipCode: 14070,
  },
  {
    countyName: "Erie",
    zipCode: 14072,
  },
  {
    countyName: "Erie",
    zipCode: 14075,
  },
  {
    countyName: "Erie",
    zipCode: 14080,
  },
  {
    countyName: "Erie",
    zipCode: 14081,
  },
  {
    countyName: "Erie",
    zipCode: 14085,
  },
  {
    countyName: "Erie",
    zipCode: 14086,
  },
  {
    countyName: "Erie",
    zipCode: 14091,
  },
  {
    countyName: "Erie",
    zipCode: 14102,
  },
  {
    countyName: "Erie",
    zipCode: 14110,
  },
  {
    countyName: "Erie",
    zipCode: 14111,
  },
  {
    countyName: "Erie",
    zipCode: 14112,
  },
  {
    countyName: "Erie",
    zipCode: 14127,
  },
  {
    countyName: "Erie",
    zipCode: 14134,
  },
  {
    countyName: "Erie",
    zipCode: 14139,
  },
  {
    countyName: "Erie",
    zipCode: 14140,
  },
  {
    countyName: "Erie",
    zipCode: 14141,
  },
  {
    countyName: "Erie",
    zipCode: 14145,
  },
  {
    countyName: "Erie",
    zipCode: 14150,
  },
  {
    countyName: "Erie",
    zipCode: 14151,
  },
  {
    countyName: "Erie",
    zipCode: 14169,
  },
  {
    countyName: "Erie",
    zipCode: 14170,
  },
  {
    countyName: "Erie",
    zipCode: 14201,
  },
  {
    countyName: "Erie",
    zipCode: 14202,
  },
  {
    countyName: "Erie",
    zipCode: 14203,
  },
  {
    countyName: "Erie",
    zipCode: 14204,
  },
  {
    countyName: "Erie",
    zipCode: 14205,
  },
  {
    countyName: "Erie",
    zipCode: 14206,
  },
  {
    countyName: "Erie",
    zipCode: 14207,
  },
  {
    countyName: "Erie",
    zipCode: 14208,
  },
  {
    countyName: "Erie",
    zipCode: 14209,
  },
  {
    countyName: "Erie",
    zipCode: 14210,
  },
  {
    countyName: "Erie",
    zipCode: 14211,
  },
  {
    countyName: "Erie",
    zipCode: 14212,
  },
  {
    countyName: "Erie",
    zipCode: 14213,
  },
  {
    countyName: "Erie",
    zipCode: 14214,
  },
  {
    countyName: "Erie",
    zipCode: 14215,
  },
  {
    countyName: "Erie",
    zipCode: 14216,
  },
  {
    countyName: "Erie",
    zipCode: 14217,
  },
  {
    countyName: "Erie",
    zipCode: 14218,
  },
  {
    countyName: "Erie",
    zipCode: 14219,
  },
  {
    countyName: "Erie",
    zipCode: 14220,
  },
  {
    countyName: "Erie",
    zipCode: 14221,
  },
  {
    countyName: "Erie",
    zipCode: 14222,
  },
  {
    countyName: "Erie",
    zipCode: 14223,
  },
  {
    countyName: "Erie",
    zipCode: 14224,
  },
  {
    countyName: "Erie",
    zipCode: 14225,
  },
  {
    countyName: "Erie",
    zipCode: 14226,
  },
  {
    countyName: "Erie",
    zipCode: 14227,
  },
  {
    countyName: "Erie",
    zipCode: 14228,
  },
  {
    countyName: "Erie",
    zipCode: 14231,
  },
  {
    countyName: "Erie",
    zipCode: 14233,
  },
  {
    countyName: "Erie",
    zipCode: 14240,
  },
  {
    countyName: "Erie",
    zipCode: 14241,
  },
  {
    countyName: "Erie",
    zipCode: 14260,
  },
  {
    countyName: "Erie",
    zipCode: 14261,
  },
  {
    countyName: "Erie",
    zipCode: 14263,
  },
  {
    countyName: "Erie",
    zipCode: 14264,
  },
  {
    countyName: "Erie",
    zipCode: 14265,
  },
  {
    countyName: "Erie",
    zipCode: 14267,
  },
  {
    countyName: "Erie",
    zipCode: 14269,
  },
  {
    countyName: "Erie",
    zipCode: 14270,
  },
  {
    countyName: "Erie",
    zipCode: 14272,
  },
  {
    countyName: "Erie",
    zipCode: 14273,
  },
  {
    countyName: "Erie",
    zipCode: 14276,
  },
  {
    countyName: "Erie",
    zipCode: 14280,
  },
  {
    countyName: "Essex",
    zipCode: 12836,
  },
  {
    countyName: "Essex",
    zipCode: 12851,
  },
  {
    countyName: "Essex",
    zipCode: 12852,
  },
  {
    countyName: "Essex",
    zipCode: 12853,
  },
  {
    countyName: "Essex",
    zipCode: 12855,
  },
  {
    countyName: "Essex",
    zipCode: 12857,
  },
  {
    countyName: "Essex",
    zipCode: 12858,
  },
  {
    countyName: "Essex",
    zipCode: 12870,
  },
  {
    countyName: "Essex",
    zipCode: 12872,
  },
  {
    countyName: "Essex",
    zipCode: 12879,
  },
  {
    countyName: "Essex",
    zipCode: 12883,
  },
  {
    countyName: "Essex",
    zipCode: 12911,
  },
  {
    countyName: "Essex",
    zipCode: 12912,
  },
  {
    countyName: "Essex",
    zipCode: 12913,
  },
  {
    countyName: "Essex",
    zipCode: 12928,
  },
  {
    countyName: "Essex",
    zipCode: 12932,
  },
  {
    countyName: "Essex",
    zipCode: 12936,
  },
  {
    countyName: "Essex",
    zipCode: 12941,
  },
  {
    countyName: "Essex",
    zipCode: 12942,
  },
  {
    countyName: "Essex",
    zipCode: 12943,
  },
  {
    countyName: "Essex",
    zipCode: 12944,
  },
  {
    countyName: "Essex",
    zipCode: 12946,
  },
  {
    countyName: "Essex",
    zipCode: 12950,
  },
  {
    countyName: "Essex",
    zipCode: 12956,
  },
  {
    countyName: "Essex",
    zipCode: 12960,
  },
  {
    countyName: "Essex",
    zipCode: 12961,
  },
  {
    countyName: "Essex",
    zipCode: 12964,
  },
  {
    countyName: "Essex",
    zipCode: 12972,
  },
  {
    countyName: "Essex",
    zipCode: 12974,
  },
  {
    countyName: "Essex",
    zipCode: 12975,
  },
  {
    countyName: "Essex",
    zipCode: 12977,
  },
  {
    countyName: "Essex",
    zipCode: 12983,
  },
  {
    countyName: "Essex",
    zipCode: 12987,
  },
  {
    countyName: "Essex",
    zipCode: 12989,
  },
  {
    countyName: "Essex",
    zipCode: 12993,
  },
  {
    countyName: "Essex",
    zipCode: 12996,
  },
  {
    countyName: "Essex",
    zipCode: 12997,
  },
  {
    countyName: "Essex",
    zipCode: 12998,
  },
  {
    countyName: "Franklin",
    zipCode: 12912,
  },
  {
    countyName: "Franklin",
    zipCode: 12913,
  },
  {
    countyName: "Franklin",
    zipCode: 12914,
  },
  {
    countyName: "Franklin",
    zipCode: 12915,
  },
  {
    countyName: "Franklin",
    zipCode: 12916,
  },
  {
    countyName: "Franklin",
    zipCode: 12917,
  },
  {
    countyName: "Franklin",
    zipCode: 12920,
  },
  {
    countyName: "Franklin",
    zipCode: 12926,
  },
  {
    countyName: "Franklin",
    zipCode: 12930,
  },
  {
    countyName: "Franklin",
    zipCode: 12937,
  },
  {
    countyName: "Franklin",
    zipCode: 12939,
  },
  {
    countyName: "Franklin",
    zipCode: 12945,
  },
  {
    countyName: "Franklin",
    zipCode: 12953,
  },
  {
    countyName: "Franklin",
    zipCode: 12955,
  },
  {
    countyName: "Franklin",
    zipCode: 12957,
  },
  {
    countyName: "Franklin",
    zipCode: 12966,
  },
  {
    countyName: "Franklin",
    zipCode: 12967,
  },
  {
    countyName: "Franklin",
    zipCode: 12969,
  },
  {
    countyName: "Franklin",
    zipCode: 12970,
  },
  {
    countyName: "Franklin",
    zipCode: 12976,
  },
  {
    countyName: "Franklin",
    zipCode: 12980,
  },
  {
    countyName: "Franklin",
    zipCode: 12983,
  },
  {
    countyName: "Franklin",
    zipCode: 12986,
  },
  {
    countyName: "Franklin",
    zipCode: 12989,
  },
  {
    countyName: "Franklin",
    zipCode: 12995,
  },
  {
    countyName: "Franklin",
    zipCode: 13655,
  },
  {
    countyName: "Franklin",
    zipCode: 13683,
  },
  {
    countyName: "Fulton",
    zipCode: 12010,
  },
  {
    countyName: "Fulton",
    zipCode: 12025,
  },
  {
    countyName: "Fulton",
    zipCode: 12032,
  },
  {
    countyName: "Fulton",
    zipCode: 12068,
  },
  {
    countyName: "Fulton",
    zipCode: 12070,
  },
  {
    countyName: "Fulton",
    zipCode: 12078,
  },
  {
    countyName: "Fulton",
    zipCode: 12086,
  },
  {
    countyName: "Fulton",
    zipCode: 12095,
  },
  {
    countyName: "Fulton",
    zipCode: 12117,
  },
  {
    countyName: "Fulton",
    zipCode: 12134,
  },
  {
    countyName: "Fulton",
    zipCode: 13329,
  },
  {
    countyName: "Fulton",
    zipCode: 13339,
  },
  {
    countyName: "Fulton",
    zipCode: 13452,
  },
  {
    countyName: "Fulton",
    zipCode: 13454,
  },
  {
    countyName: "Fulton",
    zipCode: 13470,
  },
  {
    countyName: "Genesee",
    zipCode: 14001,
  },
  {
    countyName: "Genesee",
    zipCode: 14004,
  },
  {
    countyName: "Genesee",
    zipCode: 14005,
  },
  {
    countyName: "Genesee",
    zipCode: 14011,
  },
  {
    countyName: "Genesee",
    zipCode: 14013,
  },
  {
    countyName: "Genesee",
    zipCode: 14020,
  },
  {
    countyName: "Genesee",
    zipCode: 14021,
  },
  {
    countyName: "Genesee",
    zipCode: 14036,
  },
  {
    countyName: "Genesee",
    zipCode: 14040,
  },
  {
    countyName: "Genesee",
    zipCode: 14054,
  },
  {
    countyName: "Genesee",
    zipCode: 14056,
  },
  {
    countyName: "Genesee",
    zipCode: 14058,
  },
  {
    countyName: "Genesee",
    zipCode: 14103,
  },
  {
    countyName: "Genesee",
    zipCode: 14105,
  },
  {
    countyName: "Genesee",
    zipCode: 14125,
  },
  {
    countyName: "Genesee",
    zipCode: 14143,
  },
  {
    countyName: "Genesee",
    zipCode: 14416,
  },
  {
    countyName: "Genesee",
    zipCode: 14422,
  },
  {
    countyName: "Genesee",
    zipCode: 14428,
  },
  {
    countyName: "Genesee",
    zipCode: 14482,
  },
  {
    countyName: "Genesee",
    zipCode: 14525,
  },
  {
    countyName: "Genesee",
    zipCode: 14557,
  },
  {
    countyName: "Genesee",
    zipCode: 14591,
  },
  {
    countyName: "Greene",
    zipCode: 12015,
  },
  {
    countyName: "Greene",
    zipCode: 12042,
  },
  {
    countyName: "Greene",
    zipCode: 12046,
  },
  {
    countyName: "Greene",
    zipCode: 12051,
  },
  {
    countyName: "Greene",
    zipCode: 12058,
  },
  {
    countyName: "Greene",
    zipCode: 12083,
  },
  {
    countyName: "Greene",
    zipCode: 12087,
  },
  {
    countyName: "Greene",
    zipCode: 12124,
  },
  {
    countyName: "Greene",
    zipCode: 12143,
  },
  {
    countyName: "Greene",
    zipCode: 12176,
  },
  {
    countyName: "Greene",
    zipCode: 12192,
  },
  {
    countyName: "Greene",
    zipCode: 12405,
  },
  {
    countyName: "Greene",
    zipCode: 12407,
  },
  {
    countyName: "Greene",
    zipCode: 12413,
  },
  {
    countyName: "Greene",
    zipCode: 12414,
  },
  {
    countyName: "Greene",
    zipCode: 12418,
  },
  {
    countyName: "Greene",
    zipCode: 12422,
  },
  {
    countyName: "Greene",
    zipCode: 12423,
  },
  {
    countyName: "Greene",
    zipCode: 12424,
  },
  {
    countyName: "Greene",
    zipCode: 12427,
  },
  {
    countyName: "Greene",
    zipCode: 12430,
  },
  {
    countyName: "Greene",
    zipCode: 12431,
  },
  {
    countyName: "Greene",
    zipCode: 12436,
  },
  {
    countyName: "Greene",
    zipCode: 12439,
  },
  {
    countyName: "Greene",
    zipCode: 12442,
  },
  {
    countyName: "Greene",
    zipCode: 12444,
  },
  {
    countyName: "Greene",
    zipCode: 12450,
  },
  {
    countyName: "Greene",
    zipCode: 12451,
  },
  {
    countyName: "Greene",
    zipCode: 12452,
  },
  {
    countyName: "Greene",
    zipCode: 12454,
  },
  {
    countyName: "Greene",
    zipCode: 12460,
  },
  {
    countyName: "Greene",
    zipCode: 12463,
  },
  {
    countyName: "Greene",
    zipCode: 12468,
  },
  {
    countyName: "Greene",
    zipCode: 12469,
  },
  {
    countyName: "Greene",
    zipCode: 12470,
  },
  {
    countyName: "Greene",
    zipCode: 12473,
  },
  {
    countyName: "Greene",
    zipCode: 12477,
  },
  {
    countyName: "Greene",
    zipCode: 12480,
  },
  {
    countyName: "Greene",
    zipCode: 12482,
  },
  {
    countyName: "Greene",
    zipCode: 12485,
  },
  {
    countyName: "Greene",
    zipCode: 12492,
  },
  {
    countyName: "Greene",
    zipCode: 12495,
  },
  {
    countyName: "Greene",
    zipCode: 12496,
  },
  {
    countyName: "Hamilton",
    zipCode: 12032,
  },
  {
    countyName: "Hamilton",
    zipCode: 12108,
  },
  {
    countyName: "Hamilton",
    zipCode: 12134,
  },
  {
    countyName: "Hamilton",
    zipCode: 12139,
  },
  {
    countyName: "Hamilton",
    zipCode: 12164,
  },
  {
    countyName: "Hamilton",
    zipCode: 12190,
  },
  {
    countyName: "Hamilton",
    zipCode: 12812,
  },
  {
    countyName: "Hamilton",
    zipCode: 12842,
  },
  {
    countyName: "Hamilton",
    zipCode: 12847,
  },
  {
    countyName: "Hamilton",
    zipCode: 12864,
  },
  {
    countyName: "Hamilton",
    zipCode: 13331,
  },
  {
    countyName: "Hamilton",
    zipCode: 13353,
  },
  {
    countyName: "Hamilton",
    zipCode: 13360,
  },
  {
    countyName: "Hamilton",
    zipCode: 13436,
  },
  {
    countyName: "Herkimer",
    zipCode: 13304,
  },
  {
    countyName: "Herkimer",
    zipCode: 13322,
  },
  {
    countyName: "Herkimer",
    zipCode: 13324,
  },
  {
    countyName: "Herkimer",
    zipCode: 13329,
  },
  {
    countyName: "Herkimer",
    zipCode: 13331,
  },
  {
    countyName: "Herkimer",
    zipCode: 13338,
  },
  {
    countyName: "Herkimer",
    zipCode: 13339,
  },
  {
    countyName: "Herkimer",
    zipCode: 13340,
  },
  {
    countyName: "Herkimer",
    zipCode: 13350,
  },
  {
    countyName: "Herkimer",
    zipCode: 13357,
  },
  {
    countyName: "Herkimer",
    zipCode: 13361,
  },
  {
    countyName: "Herkimer",
    zipCode: 13365,
  },
  {
    countyName: "Herkimer",
    zipCode: 13367,
  },
  {
    countyName: "Herkimer",
    zipCode: 13406,
  },
  {
    countyName: "Herkimer",
    zipCode: 13407,
  },
  {
    countyName: "Herkimer",
    zipCode: 13413,
  },
  {
    countyName: "Herkimer",
    zipCode: 13416,
  },
  {
    countyName: "Herkimer",
    zipCode: 13420,
  },
  {
    countyName: "Herkimer",
    zipCode: 13431,
  },
  {
    countyName: "Herkimer",
    zipCode: 13438,
  },
  {
    countyName: "Herkimer",
    zipCode: 13439,
  },
  {
    countyName: "Herkimer",
    zipCode: 13454,
  },
  {
    countyName: "Herkimer",
    zipCode: 13456,
  },
  {
    countyName: "Herkimer",
    zipCode: 13470,
  },
  {
    countyName: "Herkimer",
    zipCode: 13472,
  },
  {
    countyName: "Herkimer",
    zipCode: 13475,
  },
  {
    countyName: "Herkimer",
    zipCode: 13491,
  },
  {
    countyName: "Herkimer",
    zipCode: 13501,
  },
  {
    countyName: "Herkimer",
    zipCode: 13502,
  },
  {
    countyName: "Jefferson",
    zipCode: 13083,
  },
  {
    countyName: "Jefferson",
    zipCode: 13145,
  },
  {
    countyName: "Jefferson",
    zipCode: 13601,
  },
  {
    countyName: "Jefferson",
    zipCode: 13602,
  },
  {
    countyName: "Jefferson",
    zipCode: 13603,
  },
  {
    countyName: "Jefferson",
    zipCode: 13605,
  },
  {
    countyName: "Jefferson",
    zipCode: 13606,
  },
  {
    countyName: "Jefferson",
    zipCode: 13607,
  },
  {
    countyName: "Jefferson",
    zipCode: 13608,
  },
  {
    countyName: "Jefferson",
    zipCode: 13611,
  },
  {
    countyName: "Jefferson",
    zipCode: 13612,
  },
  {
    countyName: "Jefferson",
    zipCode: 13615,
  },
  {
    countyName: "Jefferson",
    zipCode: 13616,
  },
  {
    countyName: "Jefferson",
    zipCode: 13618,
  },
  {
    countyName: "Jefferson",
    zipCode: 13619,
  },
  {
    countyName: "Jefferson",
    zipCode: 13622,
  },
  {
    countyName: "Jefferson",
    zipCode: 13624,
  },
  {
    countyName: "Jefferson",
    zipCode: 13626,
  },
  {
    countyName: "Jefferson",
    zipCode: 13628,
  },
  {
    countyName: "Jefferson",
    zipCode: 13631,
  },
  {
    countyName: "Jefferson",
    zipCode: 13632,
  },
  {
    countyName: "Jefferson",
    zipCode: 13634,
  },
  {
    countyName: "Jefferson",
    zipCode: 13636,
  },
  {
    countyName: "Jefferson",
    zipCode: 13637,
  },
  {
    countyName: "Jefferson",
    zipCode: 13638,
  },
  {
    countyName: "Jefferson",
    zipCode: 13640,
  },
  {
    countyName: "Jefferson",
    zipCode: 13641,
  },
  {
    countyName: "Jefferson",
    zipCode: 13643,
  },
  {
    countyName: "Jefferson",
    zipCode: 13646,
  },
  {
    countyName: "Jefferson",
    zipCode: 13650,
  },
  {
    countyName: "Jefferson",
    zipCode: 13651,
  },
  {
    countyName: "Jefferson",
    zipCode: 13656,
  },
  {
    countyName: "Jefferson",
    zipCode: 13659,
  },
  {
    countyName: "Jefferson",
    zipCode: 13661,
  },
  {
    countyName: "Jefferson",
    zipCode: 13665,
  },
  {
    countyName: "Jefferson",
    zipCode: 13671,
  },
  {
    countyName: "Jefferson",
    zipCode: 13673,
  },
  {
    countyName: "Jefferson",
    zipCode: 13674,
  },
  {
    countyName: "Jefferson",
    zipCode: 13675,
  },
  {
    countyName: "Jefferson",
    zipCode: 13679,
  },
  {
    countyName: "Jefferson",
    zipCode: 13682,
  },
  {
    countyName: "Jefferson",
    zipCode: 13685,
  },
  {
    countyName: "Jefferson",
    zipCode: 13691,
  },
  {
    countyName: "Jefferson",
    zipCode: 13692,
  },
  {
    countyName: "Jefferson",
    zipCode: 13693,
  },
  {
    countyName: "Lewis",
    zipCode: 13305,
  },
  {
    countyName: "Lewis",
    zipCode: 13309,
  },
  {
    countyName: "Lewis",
    zipCode: 13312,
  },
  {
    countyName: "Lewis",
    zipCode: 13316,
  },
  {
    countyName: "Lewis",
    zipCode: 13325,
  },
  {
    countyName: "Lewis",
    zipCode: 13327,
  },
  {
    countyName: "Lewis",
    zipCode: 13343,
  },
  {
    countyName: "Lewis",
    zipCode: 13345,
  },
  {
    countyName: "Lewis",
    zipCode: 13367,
  },
  {
    countyName: "Lewis",
    zipCode: 13368,
  },
  {
    countyName: "Lewis",
    zipCode: 13404,
  },
  {
    countyName: "Lewis",
    zipCode: 13433,
  },
  {
    countyName: "Lewis",
    zipCode: 13437,
  },
  {
    countyName: "Lewis",
    zipCode: 13471,
  },
  {
    countyName: "Lewis",
    zipCode: 13473,
  },
  {
    countyName: "Lewis",
    zipCode: 13489,
  },
  {
    countyName: "Lewis",
    zipCode: 13619,
  },
  {
    countyName: "Lewis",
    zipCode: 13620,
  },
  {
    countyName: "Lewis",
    zipCode: 13626,
  },
  {
    countyName: "Lewis",
    zipCode: 13627,
  },
  {
    countyName: "Lewis",
    zipCode: 13648,
  },
  {
    countyName: "Lewis",
    zipCode: 13665,
  },
  {
    countyName: "Lewis",
    zipCode: 13682,
  },
  {
    countyName: "Livingston",
    zipCode: 14414,
  },
  {
    countyName: "Livingston",
    zipCode: 14423,
  },
  {
    countyName: "Livingston",
    zipCode: 14435,
  },
  {
    countyName: "Livingston",
    zipCode: 14437,
  },
  {
    countyName: "Livingston",
    zipCode: 14454,
  },
  {
    countyName: "Livingston",
    zipCode: 14462,
  },
  {
    countyName: "Livingston",
    zipCode: 14466,
  },
  {
    countyName: "Livingston",
    zipCode: 14472,
  },
  {
    countyName: "Livingston",
    zipCode: 14480,
  },
  {
    countyName: "Livingston",
    zipCode: 14481,
  },
  {
    countyName: "Livingston",
    zipCode: 14482,
  },
  {
    countyName: "Livingston",
    zipCode: 14485,
  },
  {
    countyName: "Livingston",
    zipCode: 14486,
  },
  {
    countyName: "Livingston",
    zipCode: 14487,
  },
  {
    countyName: "Livingston",
    zipCode: 14488,
  },
  {
    countyName: "Livingston",
    zipCode: 14510,
  },
  {
    countyName: "Livingston",
    zipCode: 14517,
  },
  {
    countyName: "Livingston",
    zipCode: 14525,
  },
  {
    countyName: "Livingston",
    zipCode: 14530,
  },
  {
    countyName: "Livingston",
    zipCode: 14533,
  },
  {
    countyName: "Livingston",
    zipCode: 14536,
  },
  {
    countyName: "Livingston",
    zipCode: 14539,
  },
  {
    countyName: "Livingston",
    zipCode: 14545,
  },
  {
    countyName: "Livingston",
    zipCode: 14556,
  },
  {
    countyName: "Livingston",
    zipCode: 14558,
  },
  {
    countyName: "Livingston",
    zipCode: 14560,
  },
  {
    countyName: "Livingston",
    zipCode: 14572,
  },
  {
    countyName: "Livingston",
    zipCode: 14592,
  },
  {
    countyName: "Livingston",
    zipCode: 14822,
  },
  {
    countyName: "Livingston",
    zipCode: 14836,
  },
  {
    countyName: "Livingston",
    zipCode: 14846,
  },
  {
    countyName: "Madison",
    zipCode: 13030,
  },
  {
    countyName: "Madison",
    zipCode: 13032,
  },
  {
    countyName: "Madison",
    zipCode: 13035,
  },
  {
    countyName: "Madison",
    zipCode: 13037,
  },
  {
    countyName: "Madison",
    zipCode: 13043,
  },
  {
    countyName: "Madison",
    zipCode: 13052,
  },
  {
    countyName: "Madison",
    zipCode: 13061,
  },
  {
    countyName: "Madison",
    zipCode: 13072,
  },
  {
    countyName: "Madison",
    zipCode: 13082,
  },
  {
    countyName: "Madison",
    zipCode: 13104,
  },
  {
    countyName: "Madison",
    zipCode: 13122,
  },
  {
    countyName: "Madison",
    zipCode: 13134,
  },
  {
    countyName: "Madison",
    zipCode: 13163,
  },
  {
    countyName: "Madison",
    zipCode: 13310,
  },
  {
    countyName: "Madison",
    zipCode: 13314,
  },
  {
    countyName: "Madison",
    zipCode: 13332,
  },
  {
    countyName: "Madison",
    zipCode: 13334,
  },
  {
    countyName: "Madison",
    zipCode: 13346,
  },
  {
    countyName: "Madison",
    zipCode: 13355,
  },
  {
    countyName: "Madison",
    zipCode: 13364,
  },
  {
    countyName: "Madison",
    zipCode: 13402,
  },
  {
    countyName: "Madison",
    zipCode: 13408,
  },
  {
    countyName: "Madison",
    zipCode: 13409,
  },
  {
    countyName: "Madison",
    zipCode: 13418,
  },
  {
    countyName: "Madison",
    zipCode: 13421,
  },
  {
    countyName: "Madison",
    zipCode: 13425,
  },
  {
    countyName: "Madison",
    zipCode: 13460,
  },
  {
    countyName: "Madison",
    zipCode: 13465,
  },
  {
    countyName: "Madison",
    zipCode: 13477,
  },
  {
    countyName: "Madison",
    zipCode: 13480,
  },
  {
    countyName: "Madison",
    zipCode: 13484,
  },
  {
    countyName: "Madison",
    zipCode: 13485,
  },
  {
    countyName: "Madison",
    zipCode: 13491,
  },
  {
    countyName: "Monroe",
    zipCode: 14410,
  },
  {
    countyName: "Monroe",
    zipCode: 14414,
  },
  {
    countyName: "Monroe",
    zipCode: 14416,
  },
  {
    countyName: "Monroe",
    zipCode: 14420,
  },
  {
    countyName: "Monroe",
    zipCode: 14428,
  },
  {
    countyName: "Monroe",
    zipCode: 14430,
  },
  {
    countyName: "Monroe",
    zipCode: 14445,
  },
  {
    countyName: "Monroe",
    zipCode: 14450,
  },
  {
    countyName: "Monroe",
    zipCode: 14464,
  },
  {
    countyName: "Monroe",
    zipCode: 14467,
  },
  {
    countyName: "Monroe",
    zipCode: 14468,
  },
  {
    countyName: "Monroe",
    zipCode: 14472,
  },
  {
    countyName: "Monroe",
    zipCode: 14476,
  },
  {
    countyName: "Monroe",
    zipCode: 14482,
  },
  {
    countyName: "Monroe",
    zipCode: 14502,
  },
  {
    countyName: "Monroe",
    zipCode: 14506,
  },
  {
    countyName: "Monroe",
    zipCode: 14508,
  },
  {
    countyName: "Monroe",
    zipCode: 14511,
  },
  {
    countyName: "Monroe",
    zipCode: 14514,
  },
  {
    countyName: "Monroe",
    zipCode: 14515,
  },
  {
    countyName: "Monroe",
    zipCode: 14526,
  },
  {
    countyName: "Monroe",
    zipCode: 14534,
  },
  {
    countyName: "Monroe",
    zipCode: 14543,
  },
  {
    countyName: "Monroe",
    zipCode: 14546,
  },
  {
    countyName: "Monroe",
    zipCode: 14559,
  },
  {
    countyName: "Monroe",
    zipCode: 14564,
  },
  {
    countyName: "Monroe",
    zipCode: 14580,
  },
  {
    countyName: "Monroe",
    zipCode: 14586,
  },
  {
    countyName: "Monroe",
    zipCode: 14602,
  },
  {
    countyName: "Monroe",
    zipCode: 14603,
  },
  {
    countyName: "Monroe",
    zipCode: 14604,
  },
  {
    countyName: "Monroe",
    zipCode: 14605,
  },
  {
    countyName: "Monroe",
    zipCode: 14606,
  },
  {
    countyName: "Monroe",
    zipCode: 14607,
  },
  {
    countyName: "Monroe",
    zipCode: 14608,
  },
  {
    countyName: "Monroe",
    zipCode: 14609,
  },
  {
    countyName: "Monroe",
    zipCode: 14610,
  },
  {
    countyName: "Monroe",
    zipCode: 14611,
  },
  {
    countyName: "Monroe",
    zipCode: 14612,
  },
  {
    countyName: "Monroe",
    zipCode: 14613,
  },
  {
    countyName: "Monroe",
    zipCode: 14614,
  },
  {
    countyName: "Monroe",
    zipCode: 14615,
  },
  {
    countyName: "Monroe",
    zipCode: 14616,
  },
  {
    countyName: "Monroe",
    zipCode: 14617,
  },
  {
    countyName: "Monroe",
    zipCode: 14618,
  },
  {
    countyName: "Monroe",
    zipCode: 14619,
  },
  {
    countyName: "Monroe",
    zipCode: 14620,
  },
  {
    countyName: "Monroe",
    zipCode: 14621,
  },
  {
    countyName: "Monroe",
    zipCode: 14622,
  },
  {
    countyName: "Monroe",
    zipCode: 14623,
  },
  {
    countyName: "Monroe",
    zipCode: 14624,
  },
  {
    countyName: "Monroe",
    zipCode: 14625,
  },
  {
    countyName: "Monroe",
    zipCode: 14626,
  },
  {
    countyName: "Monroe",
    zipCode: 14627,
  },
  {
    countyName: "Monroe",
    zipCode: 14638,
  },
  {
    countyName: "Monroe",
    zipCode: 14639,
  },
  {
    countyName: "Monroe",
    zipCode: 14642,
  },
  {
    countyName: "Monroe",
    zipCode: 14643,
  },
  {
    countyName: "Monroe",
    zipCode: 14644,
  },
  {
    countyName: "Monroe",
    zipCode: 14645,
  },
  {
    countyName: "Monroe",
    zipCode: 14646,
  },
  {
    countyName: "Monroe",
    zipCode: 14647,
  },
  {
    countyName: "Monroe",
    zipCode: 14649,
  },
  {
    countyName: "Monroe",
    zipCode: 14650,
  },
  {
    countyName: "Monroe",
    zipCode: 14651,
  },
  {
    countyName: "Monroe",
    zipCode: 14652,
  },
  {
    countyName: "Monroe",
    zipCode: 14653,
  },
  {
    countyName: "Monroe",
    zipCode: 14664,
  },
  {
    countyName: "Monroe",
    zipCode: 14673,
  },
  {
    countyName: "Monroe",
    zipCode: 14683,
  },
  {
    countyName: "Monroe",
    zipCode: 14692,
  },
  {
    countyName: "Monroe",
    zipCode: 14694,
  },
  {
    countyName: "Montgomery",
    zipCode: 12010,
  },
  {
    countyName: "Montgomery",
    zipCode: 12016,
  },
  {
    countyName: "Montgomery",
    zipCode: 12066,
  },
  {
    countyName: "Montgomery",
    zipCode: 12068,
  },
  {
    countyName: "Montgomery",
    zipCode: 12069,
  },
  {
    countyName: "Montgomery",
    zipCode: 12070,
  },
  {
    countyName: "Montgomery",
    zipCode: 12072,
  },
  {
    countyName: "Montgomery",
    zipCode: 12086,
  },
  {
    countyName: "Montgomery",
    zipCode: 12095,
  },
  {
    countyName: "Montgomery",
    zipCode: 12137,
  },
  {
    countyName: "Montgomery",
    zipCode: 12160,
  },
  {
    countyName: "Montgomery",
    zipCode: 12166,
  },
  {
    countyName: "Montgomery",
    zipCode: 12177,
  },
  {
    countyName: "Montgomery",
    zipCode: 13317,
  },
  {
    countyName: "Montgomery",
    zipCode: 13320,
  },
  {
    countyName: "Montgomery",
    zipCode: 13339,
  },
  {
    countyName: "Montgomery",
    zipCode: 13410,
  },
  {
    countyName: "Montgomery",
    zipCode: 13428,
  },
  {
    countyName: "Montgomery",
    zipCode: 13452,
  },
  {
    countyName: "Montgomery",
    zipCode: 13459,
  },
  {
    countyName: "Niagara",
    zipCode: 14001,
  },
  {
    countyName: "Niagara",
    zipCode: 14008,
  },
  {
    countyName: "Niagara",
    zipCode: 14012,
  },
  {
    countyName: "Niagara",
    zipCode: 14028,
  },
  {
    countyName: "Niagara",
    zipCode: 14032,
  },
  {
    countyName: "Niagara",
    zipCode: 14067,
  },
  {
    countyName: "Niagara",
    zipCode: 14092,
  },
  {
    countyName: "Niagara",
    zipCode: 14094,
  },
  {
    countyName: "Niagara",
    zipCode: 14095,
  },
  {
    countyName: "Niagara",
    zipCode: 14105,
  },
  {
    countyName: "Niagara",
    zipCode: 14107,
  },
  {
    countyName: "Niagara",
    zipCode: 14108,
  },
  {
    countyName: "Niagara",
    zipCode: 14109,
  },
  {
    countyName: "Niagara",
    zipCode: 14120,
  },
  {
    countyName: "Niagara",
    zipCode: 14126,
  },
  {
    countyName: "Niagara",
    zipCode: 14131,
  },
  {
    countyName: "Niagara",
    zipCode: 14132,
  },
  {
    countyName: "Niagara",
    zipCode: 14144,
  },
  {
    countyName: "Niagara",
    zipCode: 14172,
  },
  {
    countyName: "Niagara",
    zipCode: 14174,
  },
  {
    countyName: "Niagara",
    zipCode: 14301,
  },
  {
    countyName: "Niagara",
    zipCode: 14302,
  },
  {
    countyName: "Niagara",
    zipCode: 14303,
  },
  {
    countyName: "Niagara",
    zipCode: 14304,
  },
  {
    countyName: "Niagara",
    zipCode: 14305,
  },
  {
    countyName: "Oneida",
    zipCode: 13032,
  },
  {
    countyName: "Oneida",
    zipCode: 13042,
  },
  {
    countyName: "Oneida",
    zipCode: 13054,
  },
  {
    countyName: "Oneida",
    zipCode: 13123,
  },
  {
    countyName: "Oneida",
    zipCode: 13157,
  },
  {
    countyName: "Oneida",
    zipCode: 13162,
  },
  {
    countyName: "Oneida",
    zipCode: 13301,
  },
  {
    countyName: "Oneida",
    zipCode: 13303,
  },
  {
    countyName: "Oneida",
    zipCode: 13304,
  },
  {
    countyName: "Oneida",
    zipCode: 13308,
  },
  {
    countyName: "Oneida",
    zipCode: 13309,
  },
  {
    countyName: "Oneida",
    zipCode: 13313,
  },
  {
    countyName: "Oneida",
    zipCode: 13316,
  },
  {
    countyName: "Oneida",
    zipCode: 13318,
  },
  {
    countyName: "Oneida",
    zipCode: 13319,
  },
  {
    countyName: "Oneida",
    zipCode: 13321,
  },
  {
    countyName: "Oneida",
    zipCode: 13322,
  },
  {
    countyName: "Oneida",
    zipCode: 13323,
  },
  {
    countyName: "Oneida",
    zipCode: 13328,
  },
  {
    countyName: "Oneida",
    zipCode: 13338,
  },
  {
    countyName: "Oneida",
    zipCode: 13340,
  },
  {
    countyName: "Oneida",
    zipCode: 13341,
  },
  {
    countyName: "Oneida",
    zipCode: 13352,
  },
  {
    countyName: "Oneida",
    zipCode: 13354,
  },
  {
    countyName: "Oneida",
    zipCode: 13362,
  },
  {
    countyName: "Oneida",
    zipCode: 13363,
  },
  {
    countyName: "Oneida",
    zipCode: 13401,
  },
  {
    countyName: "Oneida",
    zipCode: 13402,
  },
  {
    countyName: "Oneida",
    zipCode: 13403,
  },
  {
    countyName: "Oneida",
    zipCode: 13409,
  },
  {
    countyName: "Oneida",
    zipCode: 13413,
  },
  {
    countyName: "Oneida",
    zipCode: 13417,
  },
  {
    countyName: "Oneida",
    zipCode: 13421,
  },
  {
    countyName: "Oneida",
    zipCode: 13424,
  },
  {
    countyName: "Oneida",
    zipCode: 13425,
  },
  {
    countyName: "Oneida",
    zipCode: 13431,
  },
  {
    countyName: "Oneida",
    zipCode: 13435,
  },
  {
    countyName: "Oneida",
    zipCode: 13438,
  },
  {
    countyName: "Oneida",
    zipCode: 13440,
  },
  {
    countyName: "Oneida",
    zipCode: 13441,
  },
  {
    countyName: "Oneida",
    zipCode: 13442,
  },
  {
    countyName: "Oneida",
    zipCode: 13455,
  },
  {
    countyName: "Oneida",
    zipCode: 13456,
  },
  {
    countyName: "Oneida",
    zipCode: 13461,
  },
  {
    countyName: "Oneida",
    zipCode: 13469,
  },
  {
    countyName: "Oneida",
    zipCode: 13471,
  },
  {
    countyName: "Oneida",
    zipCode: 13476,
  },
  {
    countyName: "Oneida",
    zipCode: 13477,
  },
  {
    countyName: "Oneida",
    zipCode: 13478,
  },
  {
    countyName: "Oneida",
    zipCode: 13479,
  },
  {
    countyName: "Oneida",
    zipCode: 13480,
  },
  {
    countyName: "Oneida",
    zipCode: 13483,
  },
  {
    countyName: "Oneida",
    zipCode: 13486,
  },
  {
    countyName: "Oneida",
    zipCode: 13490,
  },
  {
    countyName: "Oneida",
    zipCode: 13492,
  },
  {
    countyName: "Oneida",
    zipCode: 13494,
  },
  {
    countyName: "Oneida",
    zipCode: 13495,
  },
  {
    countyName: "Oneida",
    zipCode: 13501,
  },
  {
    countyName: "Oneida",
    zipCode: 13502,
  },
  {
    countyName: "Oneida",
    zipCode: 13503,
  },
  {
    countyName: "Oneida",
    zipCode: 13504,
  },
  {
    countyName: "Oneida",
    zipCode: 13505,
  },
  {
    countyName: "Oneida",
    zipCode: 13599,
  },
  {
    countyName: "Onondaga",
    zipCode: 13020,
  },
  {
    countyName: "Onondaga",
    zipCode: 13027,
  },
  {
    countyName: "Onondaga",
    zipCode: 13029,
  },
  {
    countyName: "Onondaga",
    zipCode: 13030,
  },
  {
    countyName: "Onondaga",
    zipCode: 13031,
  },
  {
    countyName: "Onondaga",
    zipCode: 13035,
  },
  {
    countyName: "Onondaga",
    zipCode: 13036,
  },
  {
    countyName: "Onondaga",
    zipCode: 13037,
  },
  {
    countyName: "Onondaga",
    zipCode: 13039,
  },
  {
    countyName: "Onondaga",
    zipCode: 13041,
  },
  {
    countyName: "Onondaga",
    zipCode: 13051,
  },
  {
    countyName: "Onondaga",
    zipCode: 13057,
  },
  {
    countyName: "Onondaga",
    zipCode: 13060,
  },
  {
    countyName: "Onondaga",
    zipCode: 13063,
  },
  {
    countyName: "Onondaga",
    zipCode: 13066,
  },
  {
    countyName: "Onondaga",
    zipCode: 13069,
  },
  {
    countyName: "Onondaga",
    zipCode: 13077,
  },
  {
    countyName: "Onondaga",
    zipCode: 13078,
  },
  {
    countyName: "Onondaga",
    zipCode: 13080,
  },
  {
    countyName: "Onondaga",
    zipCode: 13082,
  },
  {
    countyName: "Onondaga",
    zipCode: 13084,
  },
  {
    countyName: "Onondaga",
    zipCode: 13088,
  },
  {
    countyName: "Onondaga",
    zipCode: 13089,
  },
  {
    countyName: "Onondaga",
    zipCode: 13090,
  },
  {
    countyName: "Onondaga",
    zipCode: 13104,
  },
  {
    countyName: "Onondaga",
    zipCode: 13108,
  },
  {
    countyName: "Onondaga",
    zipCode: 13110,
  },
  {
    countyName: "Onondaga",
    zipCode: 13112,
  },
  {
    countyName: "Onondaga",
    zipCode: 13116,
  },
  {
    countyName: "Onondaga",
    zipCode: 13119,
  },
  {
    countyName: "Onondaga",
    zipCode: 13120,
  },
  {
    countyName: "Onondaga",
    zipCode: 13122,
  },
  {
    countyName: "Onondaga",
    zipCode: 13135,
  },
  {
    countyName: "Onondaga",
    zipCode: 13137,
  },
  {
    countyName: "Onondaga",
    zipCode: 13138,
  },
  {
    countyName: "Onondaga",
    zipCode: 13141,
  },
  {
    countyName: "Onondaga",
    zipCode: 13152,
  },
  {
    countyName: "Onondaga",
    zipCode: 13153,
  },
  {
    countyName: "Onondaga",
    zipCode: 13158,
  },
  {
    countyName: "Onondaga",
    zipCode: 13159,
  },
  {
    countyName: "Onondaga",
    zipCode: 13164,
  },
  {
    countyName: "Onondaga",
    zipCode: 13166,
  },
  {
    countyName: "Onondaga",
    zipCode: 13201,
  },
  {
    countyName: "Onondaga",
    zipCode: 13202,
  },
  {
    countyName: "Onondaga",
    zipCode: 13203,
  },
  {
    countyName: "Onondaga",
    zipCode: 13204,
  },
  {
    countyName: "Onondaga",
    zipCode: 13205,
  },
  {
    countyName: "Onondaga",
    zipCode: 13206,
  },
  {
    countyName: "Onondaga",
    zipCode: 13207,
  },
  {
    countyName: "Onondaga",
    zipCode: 13208,
  },
  {
    countyName: "Onondaga",
    zipCode: 13209,
  },
  {
    countyName: "Onondaga",
    zipCode: 13210,
  },
  {
    countyName: "Onondaga",
    zipCode: 13211,
  },
  {
    countyName: "Onondaga",
    zipCode: 13212,
  },
  {
    countyName: "Onondaga",
    zipCode: 13214,
  },
  {
    countyName: "Onondaga",
    zipCode: 13215,
  },
  {
    countyName: "Onondaga",
    zipCode: 13217,
  },
  {
    countyName: "Onondaga",
    zipCode: 13218,
  },
  {
    countyName: "Onondaga",
    zipCode: 13219,
  },
  {
    countyName: "Onondaga",
    zipCode: 13220,
  },
  {
    countyName: "Onondaga",
    zipCode: 13221,
  },
  {
    countyName: "Onondaga",
    zipCode: 13224,
  },
  {
    countyName: "Onondaga",
    zipCode: 13225,
  },
  {
    countyName: "Onondaga",
    zipCode: 13235,
  },
  {
    countyName: "Onondaga",
    zipCode: 13244,
  },
  {
    countyName: "Onondaga",
    zipCode: 13250,
  },
  {
    countyName: "Onondaga",
    zipCode: 13251,
  },
  {
    countyName: "Onondaga",
    zipCode: 13252,
  },
  {
    countyName: "Onondaga",
    zipCode: 13261,
  },
  {
    countyName: "Onondaga",
    zipCode: 13290,
  },
  {
    countyName: "Ontario",
    zipCode: 14424,
  },
  {
    countyName: "Ontario",
    zipCode: 14425,
  },
  {
    countyName: "Ontario",
    zipCode: 14432,
  },
  {
    countyName: "Ontario",
    zipCode: 14443,
  },
  {
    countyName: "Ontario",
    zipCode: 14453,
  },
  {
    countyName: "Ontario",
    zipCode: 14456,
  },
  {
    countyName: "Ontario",
    zipCode: 14461,
  },
  {
    countyName: "Ontario",
    zipCode: 14463,
  },
  {
    countyName: "Ontario",
    zipCode: 14466,
  },
  {
    countyName: "Ontario",
    zipCode: 14469,
  },
  {
    countyName: "Ontario",
    zipCode: 14471,
  },
  {
    countyName: "Ontario",
    zipCode: 14472,
  },
  {
    countyName: "Ontario",
    zipCode: 14475,
  },
  {
    countyName: "Ontario",
    zipCode: 14485,
  },
  {
    countyName: "Ontario",
    zipCode: 14487,
  },
  {
    countyName: "Ontario",
    zipCode: 14489,
  },
  {
    countyName: "Ontario",
    zipCode: 14504,
  },
  {
    countyName: "Ontario",
    zipCode: 14512,
  },
  {
    countyName: "Ontario",
    zipCode: 14513,
  },
  {
    countyName: "Ontario",
    zipCode: 14518,
  },
  {
    countyName: "Ontario",
    zipCode: 14522,
  },
  {
    countyName: "Ontario",
    zipCode: 14532,
  },
  {
    countyName: "Ontario",
    zipCode: 14534,
  },
  {
    countyName: "Ontario",
    zipCode: 14537,
  },
  {
    countyName: "Ontario",
    zipCode: 14544,
  },
  {
    countyName: "Ontario",
    zipCode: 14547,
  },
  {
    countyName: "Ontario",
    zipCode: 14548,
  },
  {
    countyName: "Ontario",
    zipCode: 14560,
  },
  {
    countyName: "Ontario",
    zipCode: 14561,
  },
  {
    countyName: "Ontario",
    zipCode: 14564,
  },
  {
    countyName: "Ontario",
    zipCode: 14585,
  },
  {
    countyName: "Orleans",
    zipCode: 14058,
  },
  {
    countyName: "Orleans",
    zipCode: 14098,
  },
  {
    countyName: "Orleans",
    zipCode: 14103,
  },
  {
    countyName: "Orleans",
    zipCode: 14105,
  },
  {
    countyName: "Orleans",
    zipCode: 14125,
  },
  {
    countyName: "Orleans",
    zipCode: 14411,
  },
  {
    countyName: "Orleans",
    zipCode: 14416,
  },
  {
    countyName: "Orleans",
    zipCode: 14420,
  },
  {
    countyName: "Orleans",
    zipCode: 14422,
  },
  {
    countyName: "Orleans",
    zipCode: 14429,
  },
  {
    countyName: "Orleans",
    zipCode: 14452,
  },
  {
    countyName: "Orleans",
    zipCode: 14470,
  },
  {
    countyName: "Orleans",
    zipCode: 14476,
  },
  {
    countyName: "Orleans",
    zipCode: 14477,
  },
  {
    countyName: "Orleans",
    zipCode: 14479,
  },
  {
    countyName: "Orleans",
    zipCode: 14571,
  },
  {
    countyName: "Oswego",
    zipCode: 13028,
  },
  {
    countyName: "Oswego",
    zipCode: 13036,
  },
  {
    countyName: "Oswego",
    zipCode: 13042,
  },
  {
    countyName: "Oswego",
    zipCode: 13044,
  },
  {
    countyName: "Oswego",
    zipCode: 13069,
  },
  {
    countyName: "Oswego",
    zipCode: 13074,
  },
  {
    countyName: "Oswego",
    zipCode: 13076,
  },
  {
    countyName: "Oswego",
    zipCode: 13083,
  },
  {
    countyName: "Oswego",
    zipCode: 13093,
  },
  {
    countyName: "Oswego",
    zipCode: 13103,
  },
  {
    countyName: "Oswego",
    zipCode: 13107,
  },
  {
    countyName: "Oswego",
    zipCode: 13111,
  },
  {
    countyName: "Oswego",
    zipCode: 13114,
  },
  {
    countyName: "Oswego",
    zipCode: 13115,
  },
  {
    countyName: "Oswego",
    zipCode: 13121,
  },
  {
    countyName: "Oswego",
    zipCode: 13126,
  },
  {
    countyName: "Oswego",
    zipCode: 13131,
  },
  {
    countyName: "Oswego",
    zipCode: 13132,
  },
  {
    countyName: "Oswego",
    zipCode: 13135,
  },
  {
    countyName: "Oswego",
    zipCode: 13142,
  },
  {
    countyName: "Oswego",
    zipCode: 13144,
  },
  {
    countyName: "Oswego",
    zipCode: 13145,
  },
  {
    countyName: "Oswego",
    zipCode: 13167,
  },
  {
    countyName: "Oswego",
    zipCode: 13302,
  },
  {
    countyName: "Oswego",
    zipCode: 13316,
  },
  {
    countyName: "Oswego",
    zipCode: 13426,
  },
  {
    countyName: "Oswego",
    zipCode: 13437,
  },
  {
    countyName: "Oswego",
    zipCode: 13483,
  },
  {
    countyName: "Oswego",
    zipCode: 13493,
  },
  {
    countyName: "Oswego",
    zipCode: 13661,
  },
  {
    countyName: "Otsego",
    zipCode: 12036,
  },
  {
    countyName: "Otsego",
    zipCode: 12043,
  },
  {
    countyName: "Otsego",
    zipCode: 12064,
  },
  {
    countyName: "Otsego",
    zipCode: 12116,
  },
  {
    countyName: "Otsego",
    zipCode: 12149,
  },
  {
    countyName: "Otsego",
    zipCode: 12155,
  },
  {
    countyName: "Otsego",
    zipCode: 12197,
  },
  {
    countyName: "Otsego",
    zipCode: 13315,
  },
  {
    countyName: "Otsego",
    zipCode: 13317,
  },
  {
    countyName: "Otsego",
    zipCode: 13320,
  },
  {
    countyName: "Otsego",
    zipCode: 13326,
  },
  {
    countyName: "Otsego",
    zipCode: 13333,
  },
  {
    countyName: "Otsego",
    zipCode: 13335,
  },
  {
    countyName: "Otsego",
    zipCode: 13337,
  },
  {
    countyName: "Otsego",
    zipCode: 13342,
  },
  {
    countyName: "Otsego",
    zipCode: 13348,
  },
  {
    countyName: "Otsego",
    zipCode: 13361,
  },
  {
    countyName: "Otsego",
    zipCode: 13411,
  },
  {
    countyName: "Otsego",
    zipCode: 13415,
  },
  {
    countyName: "Otsego",
    zipCode: 13439,
  },
  {
    countyName: "Otsego",
    zipCode: 13450,
  },
  {
    countyName: "Otsego",
    zipCode: 13457,
  },
  {
    countyName: "Otsego",
    zipCode: 13468,
  },
  {
    countyName: "Otsego",
    zipCode: 13482,
  },
  {
    countyName: "Otsego",
    zipCode: 13485,
  },
  {
    countyName: "Otsego",
    zipCode: 13488,
  },
  {
    countyName: "Otsego",
    zipCode: 13491,
  },
  {
    countyName: "Otsego",
    zipCode: 13733,
  },
  {
    countyName: "Otsego",
    zipCode: 13747,
  },
  {
    countyName: "Otsego",
    zipCode: 13750,
  },
  {
    countyName: "Otsego",
    zipCode: 13776,
  },
  {
    countyName: "Otsego",
    zipCode: 13796,
  },
  {
    countyName: "Otsego",
    zipCode: 13807,
  },
  {
    countyName: "Otsego",
    zipCode: 13808,
  },
  {
    countyName: "Otsego",
    zipCode: 13809,
  },
  {
    countyName: "Otsego",
    zipCode: 13810,
  },
  {
    countyName: "Otsego",
    zipCode: 13820,
  },
  {
    countyName: "Otsego",
    zipCode: 13825,
  },
  {
    countyName: "Otsego",
    zipCode: 13834,
  },
  {
    countyName: "Otsego",
    zipCode: 13838,
  },
  {
    countyName: "Otsego",
    zipCode: 13843,
  },
  {
    countyName: "Otsego",
    zipCode: 13849,
  },
  {
    countyName: "Otsego",
    zipCode: 13859,
  },
  {
    countyName: "Otsego",
    zipCode: 13861,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12018,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12022,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12028,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12033,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12040,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12052,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12057,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12061,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12062,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12063,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12082,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12089,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12090,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12094,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12118,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12121,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12123,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12133,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12138,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12140,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12144,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12153,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12154,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12156,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12168,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12169,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12180,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12181,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12182,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12184,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12185,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12196,
  },
  {
    countyName: "Rensselaer",
    zipCode: 12198,
  },
  {
    countyName: "Rockland",
    zipCode: 10901,
  },
  {
    countyName: "Saratoga",
    zipCode: 12010,
  },
  {
    countyName: "Saratoga",
    zipCode: 12019,
  },
  {
    countyName: "Saratoga",
    zipCode: 12020,
  },
  {
    countyName: "Saratoga",
    zipCode: 12025,
  },
  {
    countyName: "Saratoga",
    zipCode: 12027,
  },
  {
    countyName: "Saratoga",
    zipCode: 12065,
  },
  {
    countyName: "Saratoga",
    zipCode: 12074,
  },
  {
    countyName: "Saratoga",
    zipCode: 12086,
  },
  {
    countyName: "Saratoga",
    zipCode: 12118,
  },
  {
    countyName: "Saratoga",
    zipCode: 12134,
  },
  {
    countyName: "Saratoga",
    zipCode: 12148,
  },
  {
    countyName: "Saratoga",
    zipCode: 12151,
  },
  {
    countyName: "Saratoga",
    zipCode: 12170,
  },
  {
    countyName: "Saratoga",
    zipCode: 12188,
  },
  {
    countyName: "Saratoga",
    zipCode: 12302,
  },
  {
    countyName: "Saratoga",
    zipCode: 12803,
  },
  {
    countyName: "Saratoga",
    zipCode: 12822,
  },
  {
    countyName: "Saratoga",
    zipCode: 12828,
  },
  {
    countyName: "Saratoga",
    zipCode: 12831,
  },
  {
    countyName: "Saratoga",
    zipCode: 12833,
  },
  {
    countyName: "Saratoga",
    zipCode: 12835,
  },
  {
    countyName: "Saratoga",
    zipCode: 12850,
  },
  {
    countyName: "Saratoga",
    zipCode: 12859,
  },
  {
    countyName: "Saratoga",
    zipCode: 12863,
  },
  {
    countyName: "Saratoga",
    zipCode: 12866,
  },
  {
    countyName: "Saratoga",
    zipCode: 12871,
  },
  {
    countyName: "Saratoga",
    zipCode: 12884,
  },
  {
    countyName: "Schenectady",
    zipCode: 12008,
  },
  {
    countyName: "Schenectady",
    zipCode: 12009,
  },
  {
    countyName: "Schenectady",
    zipCode: 12019,
  },
  {
    countyName: "Schenectady",
    zipCode: 12027,
  },
  {
    countyName: "Schenectady",
    zipCode: 12053,
  },
  {
    countyName: "Schenectady",
    zipCode: 12056,
  },
  {
    countyName: "Schenectady",
    zipCode: 12066,
  },
  {
    countyName: "Schenectady",
    zipCode: 12137,
  },
  {
    countyName: "Schenectady",
    zipCode: 12141,
  },
  {
    countyName: "Schenectady",
    zipCode: 12150,
  },
  {
    countyName: "Schenectady",
    zipCode: 12157,
  },
  {
    countyName: "Schenectady",
    zipCode: 12301,
  },
  {
    countyName: "Schenectady",
    zipCode: 12302,
  },
  {
    countyName: "Schenectady",
    zipCode: 12303,
  },
  {
    countyName: "Schenectady",
    zipCode: 12304,
  },
  {
    countyName: "Schenectady",
    zipCode: 12305,
  },
  {
    countyName: "Schenectady",
    zipCode: 12306,
  },
  {
    countyName: "Schenectady",
    zipCode: 12307,
  },
  {
    countyName: "Schenectady",
    zipCode: 12308,
  },
  {
    countyName: "Schenectady",
    zipCode: 12309,
  },
  {
    countyName: "Schenectady",
    zipCode: 12325,
  },
  {
    countyName: "Schenectady",
    zipCode: 12345,
  },
  {
    countyName: "Schoharie",
    zipCode: 12023,
  },
  {
    countyName: "Schoharie",
    zipCode: 12031,
  },
  {
    countyName: "Schoharie",
    zipCode: 12035,
  },
  {
    countyName: "Schoharie",
    zipCode: 12036,
  },
  {
    countyName: "Schoharie",
    zipCode: 12043,
  },
  {
    countyName: "Schoharie",
    zipCode: 12053,
  },
  {
    countyName: "Schoharie",
    zipCode: 12064,
  },
  {
    countyName: "Schoharie",
    zipCode: 12066,
  },
  {
    countyName: "Schoharie",
    zipCode: 12071,
  },
  {
    countyName: "Schoharie",
    zipCode: 12073,
  },
  {
    countyName: "Schoharie",
    zipCode: 12076,
  },
  {
    countyName: "Schoharie",
    zipCode: 12092,
  },
  {
    countyName: "Schoharie",
    zipCode: 12093,
  },
  {
    countyName: "Schoharie",
    zipCode: 12122,
  },
  {
    countyName: "Schoharie",
    zipCode: 12131,
  },
  {
    countyName: "Schoharie",
    zipCode: 12149,
  },
  {
    countyName: "Schoharie",
    zipCode: 12157,
  },
  {
    countyName: "Schoharie",
    zipCode: 12160,
  },
  {
    countyName: "Schoharie",
    zipCode: 12166,
  },
  {
    countyName: "Schoharie",
    zipCode: 12167,
  },
  {
    countyName: "Schoharie",
    zipCode: 12175,
  },
  {
    countyName: "Schoharie",
    zipCode: 12187,
  },
  {
    countyName: "Schoharie",
    zipCode: 12194,
  },
  {
    countyName: "Schoharie",
    zipCode: 12469,
  },
  {
    countyName: "Schoharie",
    zipCode: 13320,
  },
  {
    countyName: "Schoharie",
    zipCode: 13459,
  },
  {
    countyName: "Schuyler",
    zipCode: 14805,
  },
  {
    countyName: "Schuyler",
    zipCode: 14812,
  },
  {
    countyName: "Schuyler",
    zipCode: 14815,
  },
  {
    countyName: "Schuyler",
    zipCode: 14818,
  },
  {
    countyName: "Schuyler",
    zipCode: 14824,
  },
  {
    countyName: "Schuyler",
    zipCode: 14837,
  },
  {
    countyName: "Schuyler",
    zipCode: 14838,
  },
  {
    countyName: "Schuyler",
    zipCode: 14840,
  },
  {
    countyName: "Schuyler",
    zipCode: 14841,
  },
  {
    countyName: "Schuyler",
    zipCode: 14845,
  },
  {
    countyName: "Schuyler",
    zipCode: 14863,
  },
  {
    countyName: "Schuyler",
    zipCode: 14864,
  },
  {
    countyName: "Schuyler",
    zipCode: 14865,
  },
  {
    countyName: "Schuyler",
    zipCode: 14869,
  },
  {
    countyName: "Schuyler",
    zipCode: 14870,
  },
  {
    countyName: "Schuyler",
    zipCode: 14876,
  },
  {
    countyName: "Schuyler",
    zipCode: 14878,
  },
  {
    countyName: "Schuyler",
    zipCode: 14886,
  },
  {
    countyName: "Schuyler",
    zipCode: 14887,
  },
  {
    countyName: "Schuyler",
    zipCode: 14889,
  },
  {
    countyName: "Schuyler",
    zipCode: 14891,
  },
  {
    countyName: "Schuyler",
    zipCode: 14893,
  },
  {
    countyName: "Seneca",
    zipCode: 13065,
  },
  {
    countyName: "Seneca",
    zipCode: 13146,
  },
  {
    countyName: "Seneca",
    zipCode: 13148,
  },
  {
    countyName: "Seneca",
    zipCode: 13165,
  },
  {
    countyName: "Seneca",
    zipCode: 14433,
  },
  {
    countyName: "Seneca",
    zipCode: 14456,
  },
  {
    countyName: "Seneca",
    zipCode: 14489,
  },
  {
    countyName: "Seneca",
    zipCode: 14521,
  },
  {
    countyName: "Seneca",
    zipCode: 14532,
  },
  {
    countyName: "Seneca",
    zipCode: 14541,
  },
  {
    countyName: "Seneca",
    zipCode: 14588,
  },
  {
    countyName: "Seneca",
    zipCode: 14841,
  },
  {
    countyName: "Seneca",
    zipCode: 14847,
  },
  {
    countyName: "Seneca",
    zipCode: 14860,
  },
  {
    countyName: "Seneca",
    zipCode: 14886,
  },
  {
    countyName: "Steuben",
    zipCode: 14418,
  },
  {
    countyName: "Steuben",
    zipCode: 14437,
  },
  {
    countyName: "Steuben",
    zipCode: 14512,
  },
  {
    countyName: "Steuben",
    zipCode: 14529,
  },
  {
    countyName: "Steuben",
    zipCode: 14572,
  },
  {
    countyName: "Steuben",
    zipCode: 14801,
  },
  {
    countyName: "Steuben",
    zipCode: 14803,
  },
  {
    countyName: "Steuben",
    zipCode: 14806,
  },
  {
    countyName: "Steuben",
    zipCode: 14807,
  },
  {
    countyName: "Steuben",
    zipCode: 14808,
  },
  {
    countyName: "Steuben",
    zipCode: 14809,
  },
  {
    countyName: "Steuben",
    zipCode: 14810,
  },
  {
    countyName: "Steuben",
    zipCode: 14812,
  },
  {
    countyName: "Steuben",
    zipCode: 14814,
  },
  {
    countyName: "Steuben",
    zipCode: 14815,
  },
  {
    countyName: "Steuben",
    zipCode: 14819,
  },
  {
    countyName: "Steuben",
    zipCode: 14820,
  },
  {
    countyName: "Steuben",
    zipCode: 14821,
  },
  {
    countyName: "Steuben",
    zipCode: 14823,
  },
  {
    countyName: "Steuben",
    zipCode: 14826,
  },
  {
    countyName: "Steuben",
    zipCode: 14827,
  },
  {
    countyName: "Steuben",
    zipCode: 14830,
  },
  {
    countyName: "Steuben",
    zipCode: 14831,
  },
  {
    countyName: "Steuben",
    zipCode: 14837,
  },
  {
    countyName: "Steuben",
    zipCode: 14839,
  },
  {
    countyName: "Steuben",
    zipCode: 14840,
  },
  {
    countyName: "Steuben",
    zipCode: 14843,
  },
  {
    countyName: "Steuben",
    zipCode: 14855,
  },
  {
    countyName: "Steuben",
    zipCode: 14856,
  },
  {
    countyName: "Steuben",
    zipCode: 14858,
  },
  {
    countyName: "Steuben",
    zipCode: 14870,
  },
  {
    countyName: "Steuben",
    zipCode: 14871,
  },
  {
    countyName: "Steuben",
    zipCode: 14873,
  },
  {
    countyName: "Steuben",
    zipCode: 14874,
  },
  {
    countyName: "Steuben",
    zipCode: 14877,
  },
  {
    countyName: "Steuben",
    zipCode: 14879,
  },
  {
    countyName: "Steuben",
    zipCode: 14885,
  },
  {
    countyName: "Steuben",
    zipCode: 14897,
  },
  {
    countyName: "Steuben",
    zipCode: 14898,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 12914,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 12922,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 12927,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 12930,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 12949,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 12957,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 12965,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 12967,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 12973,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 12980,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 12986,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13608,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13613,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13614,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13617,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13621,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13623,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13625,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13630,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13633,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13635,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13639,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13642,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13645,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13646,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13647,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13648,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13649,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13652,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13654,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13658,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13660,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13662,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13664,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13666,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13667,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13668,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13669,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13670,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13672,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13676,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13677,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13678,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13679,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13680,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13681,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13684,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13687,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13690,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13694,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13695,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13696,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13697,
  },
  {
    countyName: "St. Lawrence",
    zipCode: 13699,
  },
  {
    countyName: "Sullivan",
    zipCode: 10940,
  },
  {
    countyName: "Sullivan",
    zipCode: 12428,
  },
  {
    countyName: "Sullivan",
    zipCode: 12458,
  },
  {
    countyName: "Sullivan",
    zipCode: 12566,
  },
  {
    countyName: "Sullivan",
    zipCode: 12701,
  },
  {
    countyName: "Sullivan",
    zipCode: 12719,
  },
  {
    countyName: "Sullivan",
    zipCode: 12720,
  },
  {
    countyName: "Sullivan",
    zipCode: 12721,
  },
  {
    countyName: "Sullivan",
    zipCode: 12722,
  },
  {
    countyName: "Sullivan",
    zipCode: 12723,
  },
  {
    countyName: "Sullivan",
    zipCode: 12724,
  },
  {
    countyName: "Sullivan",
    zipCode: 12725,
  },
  {
    countyName: "Sullivan",
    zipCode: 12726,
  },
  {
    countyName: "Sullivan",
    zipCode: 12727,
  },
  {
    countyName: "Sullivan",
    zipCode: 12729,
  },
  {
    countyName: "Sullivan",
    zipCode: 12732,
  },
  {
    countyName: "Sullivan",
    zipCode: 12733,
  },
  {
    countyName: "Sullivan",
    zipCode: 12734,
  },
  {
    countyName: "Sullivan",
    zipCode: 12736,
  },
  {
    countyName: "Sullivan",
    zipCode: 12737,
  },
  {
    countyName: "Sullivan",
    zipCode: 12738,
  },
  {
    countyName: "Sullivan",
    zipCode: 12740,
  },
  {
    countyName: "Sullivan",
    zipCode: 12741,
  },
  {
    countyName: "Sullivan",
    zipCode: 12742,
  },
  {
    countyName: "Sullivan",
    zipCode: 12743,
  },
  {
    countyName: "Sullivan",
    zipCode: 12745,
  },
  {
    countyName: "Sullivan",
    zipCode: 12747,
  },
  {
    countyName: "Sullivan",
    zipCode: 12748,
  },
  {
    countyName: "Sullivan",
    zipCode: 12749,
  },
  {
    countyName: "Sullivan",
    zipCode: 12750,
  },
  {
    countyName: "Sullivan",
    zipCode: 12751,
  },
  {
    countyName: "Sullivan",
    zipCode: 12752,
  },
  {
    countyName: "Sullivan",
    zipCode: 12754,
  },
  {
    countyName: "Sullivan",
    zipCode: 12758,
  },
  {
    countyName: "Sullivan",
    zipCode: 12759,
  },
  {
    countyName: "Sullivan",
    zipCode: 12760,
  },
  {
    countyName: "Sullivan",
    zipCode: 12762,
  },
  {
    countyName: "Sullivan",
    zipCode: 12763,
  },
  {
    countyName: "Sullivan",
    zipCode: 12764,
  },
  {
    countyName: "Sullivan",
    zipCode: 12765,
  },
  {
    countyName: "Sullivan",
    zipCode: 12766,
  },
  {
    countyName: "Sullivan",
    zipCode: 12767,
  },
  {
    countyName: "Sullivan",
    zipCode: 12768,
  },
  {
    countyName: "Sullivan",
    zipCode: 12769,
  },
  {
    countyName: "Sullivan",
    zipCode: 12770,
  },
  {
    countyName: "Sullivan",
    zipCode: 12775,
  },
  {
    countyName: "Sullivan",
    zipCode: 12776,
  },
  {
    countyName: "Sullivan",
    zipCode: 12777,
  },
  {
    countyName: "Sullivan",
    zipCode: 12778,
  },
  {
    countyName: "Sullivan",
    zipCode: 12779,
  },
  {
    countyName: "Sullivan",
    zipCode: 12780,
  },
  {
    countyName: "Sullivan",
    zipCode: 12781,
  },
  {
    countyName: "Sullivan",
    zipCode: 12783,
  },
  {
    countyName: "Sullivan",
    zipCode: 12784,
  },
  {
    countyName: "Sullivan",
    zipCode: 12786,
  },
  {
    countyName: "Sullivan",
    zipCode: 12787,
  },
  {
    countyName: "Sullivan",
    zipCode: 12788,
  },
  {
    countyName: "Sullivan",
    zipCode: 12789,
  },
  {
    countyName: "Sullivan",
    zipCode: 12790,
  },
  {
    countyName: "Sullivan",
    zipCode: 12791,
  },
  {
    countyName: "Sullivan",
    zipCode: 12792,
  },
  {
    countyName: "Tioga",
    zipCode: 13732,
  },
  {
    countyName: "Tioga",
    zipCode: 13734,
  },
  {
    countyName: "Tioga",
    zipCode: 13736,
  },
  {
    countyName: "Tioga",
    zipCode: 13743,
  },
  {
    countyName: "Tioga",
    zipCode: 13760,
  },
  {
    countyName: "Tioga",
    zipCode: 13811,
  },
  {
    countyName: "Tioga",
    zipCode: 13812,
  },
  {
    countyName: "Tioga",
    zipCode: 13827,
  },
  {
    countyName: "Tioga",
    zipCode: 13835,
  },
  {
    countyName: "Tioga",
    zipCode: 13840,
  },
  {
    countyName: "Tioga",
    zipCode: 13845,
  },
  {
    countyName: "Tioga",
    zipCode: 13864,
  },
  {
    countyName: "Tioga",
    zipCode: 14817,
  },
  {
    countyName: "Tioga",
    zipCode: 14859,
  },
  {
    countyName: "Tioga",
    zipCode: 14883,
  },
  {
    countyName: "Tioga",
    zipCode: 14889,
  },
  {
    countyName: "Tioga",
    zipCode: 14892,
  },
  {
    countyName: "Tompkins",
    zipCode: 13045,
  },
  {
    countyName: "Tompkins",
    zipCode: 13053,
  },
  {
    countyName: "Tompkins",
    zipCode: 13062,
  },
  {
    countyName: "Tompkins",
    zipCode: 13068,
  },
  {
    countyName: "Tompkins",
    zipCode: 13073,
  },
  {
    countyName: "Tompkins",
    zipCode: 13092,
  },
  {
    countyName: "Tompkins",
    zipCode: 13102,
  },
  {
    countyName: "Tompkins",
    zipCode: 13736,
  },
  {
    countyName: "Tompkins",
    zipCode: 13864,
  },
  {
    countyName: "Tompkins",
    zipCode: 14817,
  },
  {
    countyName: "Tompkins",
    zipCode: 14850,
  },
  {
    countyName: "Tompkins",
    zipCode: 14851,
  },
  {
    countyName: "Tompkins",
    zipCode: 14852,
  },
  {
    countyName: "Tompkins",
    zipCode: 14853,
  },
  {
    countyName: "Tompkins",
    zipCode: 14854,
  },
  {
    countyName: "Tompkins",
    zipCode: 14867,
  },
  {
    countyName: "Tompkins",
    zipCode: 14881,
  },
  {
    countyName: "Tompkins",
    zipCode: 14882,
  },
  {
    countyName: "Tompkins",
    zipCode: 14883,
  },
  {
    countyName: "Tompkins",
    zipCode: 14886,
  },
  {
    countyName: "Ulster",
    zipCode: 12401,
  },
  {
    countyName: "Ulster",
    zipCode: 12402,
  },
  {
    countyName: "Ulster",
    zipCode: 12404,
  },
  {
    countyName: "Ulster",
    zipCode: 12406,
  },
  {
    countyName: "Ulster",
    zipCode: 12409,
  },
  {
    countyName: "Ulster",
    zipCode: 12410,
  },
  {
    countyName: "Ulster",
    zipCode: 12411,
  },
  {
    countyName: "Ulster",
    zipCode: 12412,
  },
  {
    countyName: "Ulster",
    zipCode: 12414,
  },
  {
    countyName: "Ulster",
    zipCode: 12416,
  },
  {
    countyName: "Ulster",
    zipCode: 12417,
  },
  {
    countyName: "Ulster",
    zipCode: 12419,
  },
  {
    countyName: "Ulster",
    zipCode: 12420,
  },
  {
    countyName: "Ulster",
    zipCode: 12428,
  },
  {
    countyName: "Ulster",
    zipCode: 12429,
  },
  {
    countyName: "Ulster",
    zipCode: 12432,
  },
  {
    countyName: "Ulster",
    zipCode: 12433,
  },
  {
    countyName: "Ulster",
    zipCode: 12435,
  },
  {
    countyName: "Ulster",
    zipCode: 12440,
  },
  {
    countyName: "Ulster",
    zipCode: 12441,
  },
  {
    countyName: "Ulster",
    zipCode: 12443,
  },
  {
    countyName: "Ulster",
    zipCode: 12446,
  },
  {
    countyName: "Ulster",
    zipCode: 12448,
  },
  {
    countyName: "Ulster",
    zipCode: 12449,
  },
  {
    countyName: "Ulster",
    zipCode: 12453,
  },
  {
    countyName: "Ulster",
    zipCode: 12456,
  },
  {
    countyName: "Ulster",
    zipCode: 12457,
  },
  {
    countyName: "Ulster",
    zipCode: 12458,
  },
  {
    countyName: "Ulster",
    zipCode: 12461,
  },
  {
    countyName: "Ulster",
    zipCode: 12463,
  },
  {
    countyName: "Ulster",
    zipCode: 12464,
  },
  {
    countyName: "Ulster",
    zipCode: 12465,
  },
  {
    countyName: "Ulster",
    zipCode: 12466,
  },
  {
    countyName: "Ulster",
    zipCode: 12471,
  },
  {
    countyName: "Ulster",
    zipCode: 12472,
  },
  {
    countyName: "Ulster",
    zipCode: 12475,
  },
  {
    countyName: "Ulster",
    zipCode: 12477,
  },
  {
    countyName: "Ulster",
    zipCode: 12480,
  },
  {
    countyName: "Ulster",
    zipCode: 12481,
  },
  {
    countyName: "Ulster",
    zipCode: 12483,
  },
  {
    countyName: "Ulster",
    zipCode: 12484,
  },
  {
    countyName: "Ulster",
    zipCode: 12486,
  },
  {
    countyName: "Ulster",
    zipCode: 12487,
  },
  {
    countyName: "Ulster",
    zipCode: 12489,
  },
  {
    countyName: "Ulster",
    zipCode: 12490,
  },
  {
    countyName: "Ulster",
    zipCode: 12491,
  },
  {
    countyName: "Ulster",
    zipCode: 12493,
  },
  {
    countyName: "Ulster",
    zipCode: 12494,
  },
  {
    countyName: "Ulster",
    zipCode: 12495,
  },
  {
    countyName: "Ulster",
    zipCode: 12498,
  },
  {
    countyName: "Ulster",
    zipCode: 12515,
  },
  {
    countyName: "Ulster",
    zipCode: 12525,
  },
  {
    countyName: "Ulster",
    zipCode: 12528,
  },
  {
    countyName: "Ulster",
    zipCode: 12542,
  },
  {
    countyName: "Ulster",
    zipCode: 12547,
  },
  {
    countyName: "Ulster",
    zipCode: 12548,
  },
  {
    countyName: "Ulster",
    zipCode: 12561,
  },
  {
    countyName: "Ulster",
    zipCode: 12566,
  },
  {
    countyName: "Ulster",
    zipCode: 12568,
  },
  {
    countyName: "Ulster",
    zipCode: 12586,
  },
  {
    countyName: "Ulster",
    zipCode: 12588,
  },
  {
    countyName: "Ulster",
    zipCode: 12589,
  },
  {
    countyName: "Ulster",
    zipCode: 12725,
  },
  {
    countyName: "Ulster",
    zipCode: 12740,
  },
  {
    countyName: "Ulster",
    zipCode: 12758,
  },
  {
    countyName: "Ulster",
    zipCode: 12763,
  },
  {
    countyName: "Warren",
    zipCode: 12801,
  },
  {
    countyName: "Warren",
    zipCode: 12804,
  },
  {
    countyName: "Warren",
    zipCode: 12808,
  },
  {
    countyName: "Warren",
    zipCode: 12810,
  },
  {
    countyName: "Warren",
    zipCode: 12811,
  },
  {
    countyName: "Warren",
    zipCode: 12814,
  },
  {
    countyName: "Warren",
    zipCode: 12815,
  },
  {
    countyName: "Warren",
    zipCode: 12817,
  },
  {
    countyName: "Warren",
    zipCode: 12820,
  },
  {
    countyName: "Warren",
    zipCode: 12824,
  },
  {
    countyName: "Warren",
    zipCode: 12835,
  },
  {
    countyName: "Warren",
    zipCode: 12836,
  },
  {
    countyName: "Warren",
    zipCode: 12839,
  },
  {
    countyName: "Warren",
    zipCode: 12843,
  },
  {
    countyName: "Warren",
    zipCode: 12844,
  },
  {
    countyName: "Warren",
    zipCode: 12845,
  },
  {
    countyName: "Warren",
    zipCode: 12846,
  },
  {
    countyName: "Warren",
    zipCode: 12853,
  },
  {
    countyName: "Warren",
    zipCode: 12856,
  },
  {
    countyName: "Warren",
    zipCode: 12857,
  },
  {
    countyName: "Warren",
    zipCode: 12860,
  },
  {
    countyName: "Warren",
    zipCode: 12862,
  },
  {
    countyName: "Warren",
    zipCode: 12870,
  },
  {
    countyName: "Warren",
    zipCode: 12874,
  },
  {
    countyName: "Warren",
    zipCode: 12878,
  },
  {
    countyName: "Warren",
    zipCode: 12885,
  },
  {
    countyName: "Warren",
    zipCode: 12886,
  },
  {
    countyName: "Washington",
    zipCode: 12028,
  },
  {
    countyName: "Washington",
    zipCode: 12057,
  },
  {
    countyName: "Washington",
    zipCode: 12154,
  },
  {
    countyName: "Washington",
    zipCode: 12185,
  },
  {
    countyName: "Washington",
    zipCode: 12804,
  },
  {
    countyName: "Washington",
    zipCode: 12809,
  },
  {
    countyName: "Washington",
    zipCode: 12816,
  },
  {
    countyName: "Washington",
    zipCode: 12819,
  },
  {
    countyName: "Washington",
    zipCode: 12821,
  },
  {
    countyName: "Washington",
    zipCode: 12823,
  },
  {
    countyName: "Washington",
    zipCode: 12827,
  },
  {
    countyName: "Washington",
    zipCode: 12828,
  },
  {
    countyName: "Washington",
    zipCode: 12832,
  },
  {
    countyName: "Washington",
    zipCode: 12834,
  },
  {
    countyName: "Washington",
    zipCode: 12837,
  },
  {
    countyName: "Washington",
    zipCode: 12838,
  },
  {
    countyName: "Washington",
    zipCode: 12839,
  },
  {
    countyName: "Washington",
    zipCode: 12841,
  },
  {
    countyName: "Washington",
    zipCode: 12844,
  },
  {
    countyName: "Washington",
    zipCode: 12848,
  },
  {
    countyName: "Washington",
    zipCode: 12849,
  },
  {
    countyName: "Washington",
    zipCode: 12854,
  },
  {
    countyName: "Washington",
    zipCode: 12861,
  },
  {
    countyName: "Washington",
    zipCode: 12865,
  },
  {
    countyName: "Washington",
    zipCode: 12873,
  },
  {
    countyName: "Washington",
    zipCode: 12883,
  },
  {
    countyName: "Washington",
    zipCode: 12887,
  },
  {
    countyName: "Wayne",
    zipCode: 13143,
  },
  {
    countyName: "Wayne",
    zipCode: 13146,
  },
  {
    countyName: "Wayne",
    zipCode: 13148,
  },
  {
    countyName: "Wayne",
    zipCode: 13154,
  },
  {
    countyName: "Wayne",
    zipCode: 13156,
  },
  {
    countyName: "Wayne",
    zipCode: 14413,
  },
  {
    countyName: "Wayne",
    zipCode: 14432,
  },
  {
    countyName: "Wayne",
    zipCode: 14433,
  },
  {
    countyName: "Wayne",
    zipCode: 14449,
  },
  {
    countyName: "Wayne",
    zipCode: 14450,
  },
  {
    countyName: "Wayne",
    zipCode: 14489,
  },
  {
    countyName: "Wayne",
    zipCode: 14502,
  },
  {
    countyName: "Wayne",
    zipCode: 14505,
  },
  {
    countyName: "Wayne",
    zipCode: 14513,
  },
  {
    countyName: "Wayne",
    zipCode: 14516,
  },
  {
    countyName: "Wayne",
    zipCode: 14519,
  },
  {
    countyName: "Wayne",
    zipCode: 14520,
  },
  {
    countyName: "Wayne",
    zipCode: 14522,
  },
  {
    countyName: "Wayne",
    zipCode: 14538,
  },
  {
    countyName: "Wayne",
    zipCode: 14542,
  },
  {
    countyName: "Wayne",
    zipCode: 14551,
  },
  {
    countyName: "Wayne",
    zipCode: 14555,
  },
  {
    countyName: "Wayne",
    zipCode: 14563,
  },
  {
    countyName: "Wayne",
    zipCode: 14564,
  },
  {
    countyName: "Wayne",
    zipCode: 14568,
  },
  {
    countyName: "Wayne",
    zipCode: 14580,
  },
  {
    countyName: "Wayne",
    zipCode: 14589,
  },
  {
    countyName: "Wayne",
    zipCode: 14590,
  },
  {
    countyName: "Wyoming",
    zipCode: 14004,
  },
  {
    countyName: "Wyoming",
    zipCode: 14009,
  },
  {
    countyName: "Wyoming",
    zipCode: 14011,
  },
  {
    countyName: "Wyoming",
    zipCode: 14024,
  },
  {
    countyName: "Wyoming",
    zipCode: 14030,
  },
  {
    countyName: "Wyoming",
    zipCode: 14037,
  },
  {
    countyName: "Wyoming",
    zipCode: 14039,
  },
  {
    countyName: "Wyoming",
    zipCode: 14040,
  },
  {
    countyName: "Wyoming",
    zipCode: 14054,
  },
  {
    countyName: "Wyoming",
    zipCode: 14066,
  },
  {
    countyName: "Wyoming",
    zipCode: 14082,
  },
  {
    countyName: "Wyoming",
    zipCode: 14083,
  },
  {
    countyName: "Wyoming",
    zipCode: 14113,
  },
  {
    countyName: "Wyoming",
    zipCode: 14130,
  },
  {
    countyName: "Wyoming",
    zipCode: 14145,
  },
  {
    countyName: "Wyoming",
    zipCode: 14167,
  },
  {
    countyName: "Wyoming",
    zipCode: 14427,
  },
  {
    countyName: "Wyoming",
    zipCode: 14481,
  },
  {
    countyName: "Wyoming",
    zipCode: 14525,
  },
  {
    countyName: "Wyoming",
    zipCode: 14530,
  },
  {
    countyName: "Wyoming",
    zipCode: 14536,
  },
  {
    countyName: "Wyoming",
    zipCode: 14549,
  },
  {
    countyName: "Wyoming",
    zipCode: 14550,
  },
  {
    countyName: "Wyoming",
    zipCode: 14569,
  },
  {
    countyName: "Wyoming",
    zipCode: 14591,
  },
  {
    countyName: "Wyoming",
    zipCode: 14735,
  },
  {
    countyName: "Yates",
    zipCode: 14415,
  },
  {
    countyName: "Yates",
    zipCode: 14418,
  },
  {
    countyName: "Yates",
    zipCode: 14441,
  },
  {
    countyName: "Yates",
    zipCode: 14456,
  },
  {
    countyName: "Yates",
    zipCode: 14478,
  },
  {
    countyName: "Yates",
    zipCode: 14507,
  },
  {
    countyName: "Yates",
    zipCode: 14512,
  },
  {
    countyName: "Yates",
    zipCode: 14527,
  },
  {
    countyName: "Yates",
    zipCode: 14544,
  },
  {
    countyName: "Yates",
    zipCode: 14561,
  },
  {
    countyName: "Yates",
    zipCode: 14837,
  },
  {
    countyName: "Yates",
    zipCode: 14842,
  },
  {
    countyName: "Yates",
    zipCode: 14857,
  },
  {
    countyName: "Yates",
    zipCode: 14878,
  },
];


class ZipCodeSearch {
  zipSearchFn() {
    const ctySearch = document.getElementById("ctySearchVal");
    const ctySearchForm = document.getElementById("ctySearchForm");
    const ctySearchResult = document.querySelector(".cty-search-result");

    ctySearchForm.addEventListener("submit", function (e) {
      e.preventDefault();
      ctySearchResult.innerHTML = "";
      var num = parseInt(ctySearch.value.trim());
      if (ctySearch.value.length !== 0) {
        let obj = {};
        zipCodeArr.forEach((item) => {
          if (item.zipCode === num) {
            obj = item;
          }
        });
        // console.log(obj.length);
        if (Object.keys(obj).length > 0) {
          ctySearchResult.innerHTML = `<div class="form-success"><p><strong>Country:</strong> ${obj.countyName} <br/>
                <strong>Zip Code:</strong> ${obj.zipCode} <br> Yes, One Day Shipping is Available!</p></div>`;
        } else {
          ctySearchResult.innerHTML = `<p style="color: #c18282;">Sorry, One-Day shipping is not available in your area (${ctySearch.value}).</p>`;
        }
      } else {
        ctySearchResult.innerHTML = `<p class="cty-error">Enter your zip code first.</p>`;
      }
    });
  }
}

new ZipCodeSearch().zipSearchFn();